import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import ReminderMe from './ReminderMe';
import AssignDropdown from './AssignDropdown';
import MyDayPlanDropdown from './MyDayPlanDropdown';
import TaskDeadline from './TaskDeadline';
import TaskStatusNextStep from './TaskStatusNextStep';
import services from '../../services';
import { useSelector } from 'react-redux';
import { useTaskData } from '../../hooks/useTaskData';
import DatePicker from 'react-datepicker';
import { FiEdit, FiLink, FiSend, FiMoreVertical, FiCopy, FiXCircle, FiPlus } from 'react-icons/fi';
import { IoIosSend } from 'react-icons/io';
import Select, { components } from 'react-select';
import DropDown from 'react-dropdown-select';
import ComposeEmail from '../composeEmail/ComposeEmail';
import { Tooltip } from 'react-tooltip';
import { useDispatch } from 'react-redux';
import { userDataLocal } from '../../utils/LocalSt';
import PNG from '../../assests/images/Png';
import { GoTag } from 'react-icons/go';
import { FaCaretRight } from 'react-icons/fa';
import { FaGripLines } from 'react-icons/fa';
import { LiaTagsSolid } from 'react-icons/lia';
import CustomTagSelect from './TagSelectDropdown';
import StatusDropdown from './StatusDropdown';
import PropertyModal from '../../common/PropertyModal';
import property from '../../api/property';
import { toast } from 'react-toastify';
import { TextField } from '@mui/material';
import fileImage from '../../assests/images/png/file.png'
import docFile from '../../assests/images/png/doc.png'
import pdfFile from '../../assests/images/png/pdf.png'
import jpgFile from '../../assests/images/png/jpg.png'
import pptFile from '../../assests/images/png/ppt.png'
import txtFile from '../../assests/images/png/txt.png'
import zipFile from '../../assests/images/png/zip.png'
import pngFile from '../../assests/images/png/png.png'
import { gmailSocket } from '../../socket';
import { PrivilegesChecker } from '../../utils/PrivilegesChecker';
import { getLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';
import ConfirmationPopup from '../ConfirmationPopup';
import { Button, Modal, Table } from 'react-bootstrap';
import { CustomSwitchButton } from '../../common/CustomSwitchButton';
import { MdDeleteOutline } from "react-icons/md";
import Confirmation from '../../common/Confirmation';
import WarningModal from '../../common/WarningModal';
import CancelBookingModal from '../../common/CancelBookingModal';
import { FaArrowRight } from "react-icons/fa";

const getFileIcon = (fileName) => {
    const ext = fileName?.split('.').pop().toLowerCase();

    switch (ext) {
        case 'pdf':
            return pdfFile;
        case 'doc':
        case 'docx':
            return docFile;
        case 'ppt':
        case 'pptx':
            return pptFile;
        case 'txt':
            return txtFile;
        case 'jpg':
        case 'jpeg':
            return jpgFile;
        case 'png':
            return pngFile;
        case 'zip':
        case 'rar':
        case '7z':
            return zipFile;
        default:
            return fileImage;
    }
};

const boardColors = ['#8BC34A', '#03A9F4', '#FF9800', '#E91E63', '#9C27B0', '#607D8B'];
const statusColors = [
    '#3b82f6',
    '#60a5fa',
    '#38bdf8',
    '#22d3ee',
    '#14b8a6',
    '#22c55e',
    '#a3e635',
    '#eab308',
    '#facc15',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#8b5cf6',
    '#a855f7',
    '#d1d5db',
    '#6b7280',
    '#374151',
    '#000000',
];

const TaskData = ({
    formattedBody,
    setBoardListId,
    gmailMassageID,
    taskItem,
    updateTaskMail,
    item,
    getTaskMail,
    setCurrentTask,
    setTaskDetailModal,
    setComposeStatus,
    threadData,
    setSelectedEmailData,
    selectedEmail,
    taskDetailsModal,
    selectedMail,
    setSelectedMail,
    handlegetEmailDetails,
    setSelectedEmailId,
    getemailbyid,
    selectedEmailData,
    selectedEmailUserGmailMessageId,
    selectedBoardId,
    childTaskData,
    selectedItem,
    setSelectedItem,
    threadMergedArray,
    setthreadMergedArray,
    originalEmail,
    setOriginalEmail,
    selectedUserId,
    selectedContact,
    currentTaskId,
    setCurrentTaskId,
    showAllAttachment,
    setShowAllAttachment,
    setAllAttachmentPathData,
    isMember,
    parentOrigin,

}) => {
    const {
        selectedMyDayPlanDate,
        selectedReminderDate,
        selectedStatusNextStepDate,
        note,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,
        handleDateSelect,
        handleUpdateTask,
    } = useTaskData();
    const userDataRaw = getLocalStorageItem('userData');
    const [newWindow, setNewWindow] = useState(null);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [copyData, setCopyData] = useState("");
    const [modal, setModal] = useState(false);
    const [selectedBookingTrip, setSelectedBookingTrip] = useState()
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [deleteID, setDeleteID] = useState("");
    const [deleteTripId, setDeleteTripId] = useState("")
    const [modalShow, setModalShow] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const actionButtonRefs = useRef({});
    const [loading, setLoading] = useState(false);
    // Cleanup new window reference
    useEffect(() => {
        const checkClosed = () => {
            if (newWindow && newWindow.closed) {
                setNewWindow(null);
            }
        };

        const interval = setInterval(checkClosed, 1000);
        return () => clearInterval(interval);
    }, [newWindow]);

    let userData;
    if (typeof userDataRaw === 'string') {
        try {
            userData = JSON.parse(userDataRaw);
        } catch {
            userData = null;
        }
    } else {
        userData = userDataRaw;
    }
    const lastCommentRef = React.useRef(null);
    const role = userData?.role;
    const name = userData?.name;
    const getColorForUser = (userName) => {
        if (!userName) return boardColors[0];
        const hash = [...userName].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const colorIndex = hash % boardColors.length;
        return boardColors[colorIndex];
    };
    const handleUpdateTaskWrapper = async (newDate, type = 'reminder') => {
        await handleUpdateTask(newDate, type, taskItem);
        try {
            if (currentTaskId) {
                await getSingleTask(currentTaskId);
            }

            if (getTaskMail) {
                getTaskMail();
            }
        } catch (error) {
            console.error('Error in handleUpdateTaskWrapper:', error);
        }
    };
    const handleDateSelectWrapper = (date, type) => {
        handleDateSelect(date, type);
        if (type === 'myDay') {
            updateMyDayDate(date);
            updateSelectedMyDayPlanDate(date);
        }
    };

    const [propertyType, setPropertyType] = useState({ name: '', icon: null, value: '' });
    const [propertyName, setPropertyName] = useState('');
    const [displayOnCard, setDisplayOnCard] = useState(false);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);
    const [taskMail, setTaskMail] = useState([]);
    const [taskAssign, setTaskAssign] = useState([]);
    const [isOpenProjectBoard, setIsOpenProjectBoard] = useState(false);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [assignedUserName, setAssignedUserName] = useState('');
    const [showReminderMeDropdown, setShowReminderMeDropdown] = useState(false);
    const [showNotes, setShowNotes] = useState(false);
    const [showMyDayPlanDropdown, setShowMyDayPlanDropdown] = useState(false);
    const [showMyDeadlineDropdown, setShowMyDeadlinDropdown] = useState(false);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const [clickedBellIcon, setClickedIcon] = useState(null);
    const [selectedColumnName, setSelectedColumnName] = useState(null);
    const [isReminder, setIsReminder] = useState(false);
    const [allUser, setAllUser] = useState([]);
    const boardName = getLocalStorageItem('board')
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [receiverEmails, setReceiverEmails] = useState([]);
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [showOptionModal, setShowOptionModal] = useState(null);
    const [inputStatusEditValue, setInputStatusValue] = useState('');
    const statusTagDropdownRef = useRef(null);
    const [tagModalIndex, setTagModalIndex] = useState(null);
    const modalRef = useRef(null);
    const [defaultStatus, setDefaultStatus] = useState([]);
    const [defaultTags, setDefaultTags] = useState([]);
    const [slaTags, setSlaTags] = useState(taskItem);
    const [selecteStatusIndex, setSelecteStatusIndex] = useState(null);
    const [selectedTagColor, setSelectedTagColor] = useState('#22c55e');
    const [selectedTagItem, setSelectedTagItem] = useState(null);
    const [inputTagValue, setInputTagValue] = useState('');
    const [customeFiedId, setCustomeFieldId] = useState(null);
    const [selectedFilterTagVal, setSelectedFilterTagVal] = useState([]);
    const [customprokey, setCustomprokey] = useState([]);
    const [triggerTaskUpdate, setTriggerTaskUpdate] = useState(false);
    const [boardIdlink, setBoardIdLink] = useState('');
    const [uploadTaskAttachment, setUploadTaskAttachment] = useState([])
    const attachmentUploadRef = useRef(null);
    const [openIndex, setOpenIndex] = useState(null);
    const [confimationModal, setConfimationModal] = useState(false);
    const handleTogglePopup = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const isDisabled = selectedMail?.boardId === null && !selectedMail?.boardListId;
    const state = useSelector(
        (state) => state.redux,
        (prev, next) => {
            return (
                prev.deadlineDate === next.deadlineDate &&
                prev.myDayDate === next.myDayDate &&
                prev.selectedReminderDate === next.selectedReminderDate &&
                prev.selectedMyDayPlanDate === next.selectedMyDayPlanDate &&
                prev.selectedStatusNextStepDate === next.selectedStatusNextStepDate &&
                prev.note === next.note &&
                prev.notesText === next.notesText &&
                prev.isMyDayChecked === next.isMyDayChecked &&
                prev.isDeadlineChecked === next.isDeadlineChecked
            );
        },
    );

    const [localNotesText, setLocalNotesText] = useState();
    const [boardList, setBoardList] = useState([]);
    const dropdownRef = useRef(null);
    const propertyRef = useRef(null);
    const notesRef = useRef(null);
    const myDayPlanDropdownRef = useRef(null);
    const myDeadlineDropdownRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [selectedBoardColor, setSelectedBoardColor] = useState(null);
    const [addPropertyData, setAddPropertyData] = useState([]);
    const [customFieldValues, setCustomFieldValues] = useState([]);
    const [statusValues, setStatusValues] = useState({});
    const [selectedTags, setSelectedTags] = useState({});
    const [singleTaskData, setSingleTaskData] = useState([]);
    const propertyTypes = [
        { name: 'Status', icon: '▶️' },
        { name: 'Tag', icon: '🏷️' },
    ];

    const handlePropertyTypeChange = (e) => {
        const selected = propertyTypes.find((pt) => pt.name === e.target.value);
        setPropertyType({
            ...selected,
            value: null,
        });
        setPropertyName(selected?.name);
    };
    const [anchorEl, setAnchorEl] = useState(null);

    const addPropertyName = (event) => {
        if (isOpenDeadline) {
            setIsOpenDeadline(false);
            setAnchorEl(null);
        } else {
            setIsOpenDeadline(true);
            setAnchorEl(event.currentTarget);
            setPropertyType({ name: '', icon: null, value: '' });
            setPropertyName('');
        }
    };

    const handlePropertyNameChange = (event) => {
        setPropertyName(event.target.value);
    };

    const handleDisplayOnCardChange = (event) => {
        setDisplayOnCard(event.target.checked);
    };
    const handleToggleSearchBox = () => {
        setIsSearchBoxOpen(!isSearchBoxOpen);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            addProperty();
            getTaskMailInbox();
            setIsOpenDeadline(false);
        }
    };

    const handleAssign = (e) => {
        if (e.key === 'Enter') {
            getTaskAssign();
        }
    };

    const getTaskMailInbox = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/addProperty/getAllAddProperty`);
            if (response) {
                setTaskMail(response?.data?.data);
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };
    const createAddProperty = async () => {
        const data = {
            type: propertyType,
            propertyName: propertyName,
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/addProperty/createaddProperty`,
                data,
            );
            if (response) {
                getTaskMailInbox();
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
        }
    };

    const deleteTaskMailProperty = async (type, propertyName, id) => {
        const data = {
            type: type,
            propertyName: propertyName,
        };
        try {
            const response = await axios.delete(
                ` ${process.env.REACT_APP_BACKEND_URL}/addProperty/deleteAddProperty/${id}`,
                data,
            );
            if (response) {
                getTaskMailInbox();
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    const getTaskAssign = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser?limit=10&email=hiteshlokhande@gmail.com`,
            );

            if (response) {
                setTaskAssign(response?.data?.data?.users);
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };

    useEffect(() => {
        getTaskMailInbox();
    }, []);

    useEffect(() => {
        getTaskAssign();
    }, []);

    const handleClearAssignment = () => {
        setAssignedUserName('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setCommentInput(value);
        const emailMatches = value.match(/@[\w.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g) || [];
        const emailParts = emailMatches.map((e) => e.slice(1).toLowerCase());
        const matchedUsers = allUser.filter((user) => emailParts.includes(user.email.toLowerCase()));
        const matchedEmails = matchedUsers.map((u) => u.email);

        setSelectedUsers(matchedUsers);
        setReceiverEmails(matchedEmails);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowReminderMeDropdown(false);
            }
            if (notesRef.current && !notesRef.current.contains(event.target)) {
                setShowNotes(false);
            }
            if (myDayPlanDropdownRef.current && !myDayPlanDropdownRef.current.contains(event.target)) {
                setShowMyDayPlanDropdown(false);
            }
            if (myDeadlineDropdownRef.current && !myDeadlineDropdownRef.current.contains(event.target)) {
                setShowMyDeadlinDropdown(false);
            }

            if (!event.target.closest('.user-dropdown-container')) {
                setShowUserDropdown(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleReminderChange = (e) => {
        updateNote(e.target.value);
    };

    const [nextStepNote, setNextStepNotes] = useState(null);
    const [filterStatusVal, setFilterStatusVal] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filterTagValue, setFilterTagValue] = useState([]);
    const [columnID, setColumnID] = useState('')
    const [boardID, setBoardID] = useState('')
    const getSingleTask = async (taskId, headers) => {

        if (!taskId) return;

        try {
            const response = await services.task.GET_TASK_BY_ID(taskId, headers);
            const singleTaskDetails = response?.data?.data;
            setShowAllAttachment(singleTaskDetails?.attachment)
            setAllAttachmentPathData(singleTaskDetails?.attachment)
            setSingleTaskData(singleTaskDetails?.customProperty);
            setCustomprokey(singleTaskDetails?.customProperty || []);
            if (singleTaskDetails?.deadline) {
                updateDeadlineDate(singleTaskDetails.deadline);
            } else {
                updateDeadlineDate(null);
            }
            if (singleTaskDetails?.addProperty?.textNotes) {
                setLocalNotesText(singleTaskDetails?.addProperty?.textNotes);
            } else {
                setLocalNotesText(null);
            }
            if (singleTaskDetails?.notes) {
                setNextStepNotes(singleTaskDetails.notes);
            } else {
                setNextStepNotes(null);
            }

            if (singleTaskDetails?.myDayPlan) {
                updateMyDayDate(singleTaskDetails.myDayPlan);
                updateSelectedMyDayPlanDate(singleTaskDetails.myDayPlan);
            } else {
                updateMyDayDate(null);
                updateSelectedMyDayPlanDate(null);
            }

            if (singleTaskDetails?.boardId) {
                setSelectedBoard(singleTaskDetails?.Board?.boardName);
                setSelectedColumnName(singleTaskDetails?.BoardList?.coloum);
                setColumnID(singleTaskDetails?.BoardList?.id)
                setBoardID(singleTaskDetails?.BoardList?.boardId)
            } else {
                setSelectedBoard(null);
                setSelectedColumnName(null);
            }

            if (singleTaskDetails?.reminder) {
                setIsReminder(true);
                updateSelectedReminderDate(singleTaskDetails.reminder);
            } else {
                setIsReminder(false);
                updateSelectedReminderDate(null);
            }

            if (singleTaskDetails?.nextStep || singleTaskDetails?.notes) {
                updateNote(singleTaskDetails?.notes);
                updateSelectedStatusNextStepDate(singleTaskDetails.nextStep);
            } else {
                updateSelectedStatusNextStepDate(null);
                updateNote(null);
            }
        } catch (error) {
            console.error('Error fetching task data:', error);
        }
    };
    const [tripId, setTripId] = useState([]);
    const copyLinkHandler = async (id) => {
        try {
            if (id) {
                const link = parentOrigin + "/trip/export/" + id;
                window.open(link, "_blank");
            }
        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);
    };
    const fetchTaskTripIds = async () => {
        if (currentTaskId) {
            try {
                const response = await services.task.GET_TRIP_BY_TASKID(currentTaskId);
                const mappedTripIds = response?.data?.data;
                setTripId(mappedTripIds);
            } catch (error) {
                console.error('Error fetching task IDs:', error);
                setTripId([]);
            }
        }
    };
    useEffect(() => {


        fetchTaskTripIds();
    }, [currentTaskId]);

    const handleUpdate = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                linkStatus: !trip?.linkStatus,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);

    };
    const handleUpdateShowPrice = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                showPrice: !trip?.showPrice,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);

    };
    const handleUpdateShowDetailPrice = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                showDetailPrice: !trip?.showDetailPrice,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);


    };
    const handleCopy = async () => {
        setLoading(true)
        const removeKeys = (obj, keysToRemove = []) =>
            Object.fromEntries(
                Object.entries(obj || {}).filter(
                    ([key]) => !keysToRemove.includes(key)
                )
            );

        try {
            if (!copyData?.id) {
                toast.error("Trip not selected");
                return;
            }
            const res = await services.task.GET_TRIP_BY_ID(copyData?.id);
            const tripData = res?.data?.data;

            if (!tripData) {
                toast.error("Trip data not found");
                return;
            }

            const cleanedTrip = removeKeys(tripData, [
                "id",
                "_id",
                "createdAt",
                "updatedAt",
                "tripId",
            ]);

            const updatedObject = {
                ...cleanedTrip,

                title: currentTaskId
                    ? `Ticket -${tripData.title} copied!`
                    : `${tripData.title} copied!`,

                linkStatus: false,
                showPrice: false,
                showDetailPrice: false,
                salesStatus: "new_request",

                ...(currentTaskId && {
                    taskId: currentTaskId,
                }),
            };

            await services.task.CREATE_TRIP(updatedObject);

            toast.success("Trip Copied");
            setCopyData("");
            setLoading(false)
            fetchTaskTripIds();
        } catch (error) {
            console.error(error);
            toast.error("Error copying trip");
        } finally {
            setLoading(false)
            setOpenActionMenu(null);
        }
    };
    const deleteTrip = async (id, tripId) => {
        setLoading(true)
        try {
            const response = await services.task.DELETE_TRIP(id);
            // await services.task.DELETE_TASK_TRIP(tripId)
            fetchTaskTripIds()
            toast.success("Trip deleted successfully!");
        } catch (error) {
            console.error(error);
            toast.error("Error deleting trip.");
        } finally {
            setLoading(false)
        }
    };
    const handleYes = () => {
        deleteTrip(deleteID, deleteTripId);

        setModalShow(false);
    };
    const openCancelModal = (trip) => {
        setSelectedBookingTrip(trip)
        setShowCancelModal(true);
    }
    const getBoardList = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            const data = response?.data?.data;
            setBoardList(data);
        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };

    const [allCustomFieldList, setAllCustomFieldList] = useState([]);

    const getAllPropertyByTaskId = async (id, propertyName, customPropData) => {
        if (!id) return;

        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(id);
            let data = response?.data?.data || [];

            // ✅ SORT ALL CUSTOM FIELDS BY INDEX
            data = [...data].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

            // ---------------- STATUS ----------------
            const defaultStatus = data.filter(
                (f) => f?.customField?.name === 'Status'
            );
            setDefaultStatus(defaultStatus);

            // ---------------- MATCHED FIELDS ----------------
            const matchedFields = [];
            customPropData?.forEach(({ selectedPropId, selectedFieldId }) => {
                const matches = data.filter(
                    (item) =>
                        item.customPropertyId === selectedPropId &&
                        selectedFieldId.includes(item.id)
                );
                matchedFields.push(...matches);
            });

            setFilterTagValue(matchedFields);

            // ---------------- SELECTED STATUS ----------------
            const mappedStatusValues = matchedFields.map((field) => ({
                value: field?.customField?.value,
                label: field?.customField?.value,
                color: field?.customField?.color || '#ccc',
                index: field?.index,
                id: field?.id,
            }));

            // ✅ ensure selected status also stays sorted
            setSelectedStatus(
                mappedStatusValues.sort((a, b) => a.index - b.index)
            );

            // ---------------- TAGS ----------------
            const defaultTag = data.filter(
                (f) => f?.customField?.name === 'Tag'
            );

            if (propertyName === 'Tag') {
                setDefaultTags(defaultTag);
            }

            // ---------------- TASK FIELDS ----------------
            const taskFields = data.filter(
                (f) => f?.taskId === taskItem?.id && f?.isProperty === true
            );

            // ---------------- GROUPED DATA ----------------
            const groupedStatus = {};
            const groupedTags = {};

            matchedFields.forEach((f) => {
                if (f?.customField?.name === 'Status') {
                    if (!groupedStatus[taskItem?.id]) groupedStatus[taskItem?.id] = {};
                    groupedStatus[taskItem?.id][f.customPropertyId] = f.customField;
                }

                if (f?.customField?.name === 'Tag') {
                    if (!groupedTags[taskItem?.id]) groupedTags[taskItem?.id] = {};
                    groupedTags[taskItem?.id][f.customPropertyId] = f.customField;
                }
            });

            setStatusValues(groupedStatus);
            setSelectedTags(groupedTags);

            setCustomFieldValues(taskFields || []);

        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };


    const [formattedTag, setFormattedTag] = useState([]);

    const getAllProperty = async () => {
        try {
            const response = await services.customfield.GET_ALL_CUSTOM_FIELD();

            const data = response?.data?.data || [];
            setAllCustomFieldList(data);
            const taskFields = data.filter((f) => f?.taskId === taskItem?.id && f?.isProperty === true);

            const groupedStatus = {};
            const groupedTags = {};

            data.forEach((f) => {
                if (f?.customField?.name === 'Status') {
                    if (!groupedStatus[taskItem?.id]) groupedStatus[taskItem?.id] = {};
                    groupedStatus[taskItem?.id][f.customPropertyId] = f.customField;
                }

                if (f?.customField?.name === 'Tag') {
                    if (!groupedTags[taskItem?.id]) groupedTags[taskItem?.id] = {};
                    groupedTags[taskItem?.id][f.customPropertyId] = f.customField;
                }
            });
            setCustomFieldValues(taskFields);
            setStatusValues(groupedStatus);
            setSelectedTags(groupedTags);
        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBoards, setFilteredBoards] = useState([]);

    useEffect(() => {
        if (boardList && Array.isArray(boardList)) {
            setFilteredBoards(
                boardList.filter((board) => board.boardName.toLowerCase().includes(searchTerm.toLowerCase())),
            );
        }
    }, [searchTerm, boardList]);
    const lastItem = formattedBody[formattedBody.length - 1];
    const subthreadID = lastItem?.subThreadId || '';

    const handleBoardChange = async (board, col) => {
        setSelectedBoard(board?.boardName);
        setSelectedColumnName(col?.coloum);
        setBoardListId(col?.id);
        try {
            let taskIdToUpdate;
            if (selectedMail?.boardId === null) {
                const response = await services.task.CREATE_TASK({
                    gmailMessageId: selectedEmail?.gmailMessageId,
                    boardId: board.id,
                    boardListId: col.id,
                    subThreadId: subthreadID,
                });
                const newTaskId = response.data.data.id;
                setCurrentTaskId(newTaskId);
                setSelectedMail((prev) => ({
                    ...prev,
                    boardId: board.id,
                }));
                taskIdToUpdate = newTaskId;
            } else {
                taskIdToUpdate = taskItem?.id;
            }
            const data = {
                boardId: col?.boardId,
                boardListId: col?.id,
            };
            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(taskIdToUpdate, data);
            getTaskMail();
            const key = `${board.id}-${col.id}`;
            const hash = [...key].reduce((acc, char) => acc + char.charCodeAt(0), 0);
            const colorIndex = hash % boardColors.length;
            setSelectedBoardColor(boardColors[colorIndex]);
        } catch (error) {
            console.error('Error updating task:', error);
        } finally {
            setIsOpenProjectBoard(false);
        }
    };
    const [activeTab, setActiveTab] = useState('comments');
    const [comments, setComments] = useState([]);
    const [hasChatPermission, setHasChatPermission] = useState(false);

    const firstRender = React.useRef(true);

    React.useEffect(() => {
        if (lastCommentRef.current) {
            if (firstRender.current) {
                lastCommentRef.current.parentElement.scrollTop = 0;
                firstRender.current = false;
            } else {
                lastCommentRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }
    }, [comments]);

    useEffect(() => {
        const checkPermission = () => {
            const permission = PrivilegesChecker('Chats') || isMember;
            setHasChatPermission(permission);
        };
        checkPermission();
    }, []);

    const [commentInput, setCommentInput] = useState('');
    const [activityLog, setActivityLog] = useState([
        { id: 1, text: 'Task created', time: 'Just now' },
        { id: 2, text: 'Assigned to user', time: '1 min ago' },
    ]);

    const extractEmailFromSendBy = (sendBy) => {
        if (!sendBy) return '';
        const emailMatch = sendBy.match(/<(.+?)>/);
        const result = emailMatch ? emailMatch[1] : sendBy;
        return result;
    };

    const ancestor = window?.location?.ancestorOrigins?.[0];

    const handleAddComment = async () => {
        if (selectedMail?.boardId === null) {
            toast.error('Please select a board and column before adding a comment.');
            return;
        }
        try {
            let sentBy = extractEmailFromSendBy(taskItem?.Email?.sentTo);
            if (selectedContact?.id) {
                taskItem.contactId = selectedContact.id;
            }
            const token = localStorage.getItem("access_token");

            let userId = null;

            if (token) {
                const payload = JSON.parse(atob(token.split(".")[1]));
                userId = payload.sub;
            }



            if (receiverEmails.length > 0) {
                const emailLinkPayload = {
                    taskId: currentTaskId,
                    gmailType: 'Gmail',
                };
                const LinkResponse = await services.task.TASK_LINK_DATA(emailLinkPayload);

                const linkId = LinkResponse?.data?.data?.id;

                if (linkId) {
                    const encodedProps = encodeURIComponent(JSON.stringify({ linkId }));
                    const childPath = `/detail/${currentTaskId}?props=${encodedProps}`;
                    const childUrl = window.location.origin + childPath;
                    const mergedUrl = `${ancestor}/kanban?redirect=${encodeURIComponent(childUrl)}`;
                    const data = {
                        taskId: currentTaskId,
                        comment: commentInput,
                        receiver: receiverEmails,
                        sender: sentBy,
                        url: mergedUrl,
                        userId
                    };
                    const res = await services.comment.SEND_COMMENT(data);
                } else {
                    console.warn(':x: No linkId found in LinkResponse');
                }
            } else {
                const payload = {
                    taskId: currentTaskId,
                    comment: commentInput,
                    userId
                };
                const resUpdate = await services.comment.CREATE_COMMENT(payload);
            }

            setCommentInput('');
            setSelectedUsers([]);
            setReceiverEmails([]);
            getComment(currentTaskId);
            getAllUser();
        } catch (error) {
            console.error(':x: Error adding comment:', error);
        }
    };

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const encodedProps = query.get('props');
        if (encodedProps) {
            const decodedProps = decodeURIComponent(encodedProps);
            const parsedProps = JSON.parse(decodedProps);
            linkData(parsedProps?.linkId);
        }
    }, [location.search]);

    const linkData = async (linkId) => {
        try {
            const response = await services.task.GET_TASK_LINK_DATA(linkId);

            const data = response?.data?.data;

            if (data) {
                setCurrentTask(data?.task);
                getComment(data?.taskId);
                getSingleTask(data?.taskId);

                setSelectedUsers(data?.task?.userId);
                setBoardIdLink(data?.task?.boardId);
                getPropertyByID(data?.task?.boardId);
            }
        } catch (error) { }
    };

    const getComment = async (id) => {
        try {
            const response = await services.comment.GET_COMMENT_BY_ID(id);
            setComments(response?.data?.data);
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
    };
    const handleUserSelection = (users) => {
        const user = users && users.length > 0 ? [users[0]] : [];
        setSelectedUsers(user);

        let newComment = commentInput
            .replace(/@[\w]+/g, '')
            .replace(/(^[\W\d]+|[\W\d]+$)/g, '')
            .replace(/@[\w-]+/g, '')
            .trim();

        if (user[0]) {
            newComment = (newComment ? newComment + ' ' : '') + '@' + user[0].name + ' ';
        }
        setCommentInput(newComment);

        const emails = user[0] ? [user[0].email] : [];
        setReceiverEmails(emails);

        setShowUserDropdown(false);
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';

        const inputDate = new Date(date);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const targetDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const msPerDay = 1000 * 60 * 60 * 24;
        const daysDiff = Math.floor((targetDay - today) / msPerDay);
        const timeString = inputDate.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        if (daysDiff === 0) return `Today, ${timeString}`;
        if (daysDiff === 1) return `Tomorrow, ${timeString}`;
        if (daysDiff === 2) return `In two days, ${timeString}`;

        return inputDate.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [editedTitle, setEditedTitle] = useState(taskItem?.title || taskItem?.subject || '');
    const debounceTimerRef = useRef(null);

    useEffect(() => {
        if (!isEditingTitle) return;

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        debounceTimerRef.current = setTimeout(() => {
            handleSaveTitle();
        }, 800);

        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, [editedTitle]);

    const handleSaveTitle = async () => {
        if (!editedTitle.trim() || editedTitle === (taskItem?.title || taskItem?.subject)) {
            setIsEditingTitle(false);
            return;
        }
        try {
            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(currentTaskId, { title: editedTitle });
            if (getTaskMail) getTaskMail();
        } catch (error) {
            console.error('Error updating title:', error);
        }
        setIsEditingTitle(false);
    };
    const fileInputRef = useRef();

    const handleAttachmentFileUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
    };
    const getAllUser = async () => {
        try {
            const falsePagination = true;
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(
                taskItem?.boardId,
                '',
                falsePagination,
            );
            const users = response?.data?.data || [];

            const uniqueUsers = Array.from(new Map(users.map((item) => [item.userId, item.User])).values());

            setAllUser(uniqueUsers);
            setSelectedUsers(uniqueUsers.length > 0 ? [uniqueUsers[0]] : []);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const getPropertyByID = async (boardId) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_BOARD_ID(boardId);
            setAddPropertyData(response?.data?.data);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const userInitial = name?.charAt(0)?.toUpperCase() || 'U';

    const getInputValue = () => commentInput;

    const toggleUserDropdown = () => {
        if (!showUserDropdown) {
            setSelectedUsers([]);
        }
        setShowUserDropdown((prev) => !prev);
    };

    const titleInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isEditingTitle && titleInputRef.current && !titleInputRef.current.contains(event.target)) {
                if (debounceTimerRef.current) {
                    clearTimeout(debounceTimerRef.current);
                }
                handleSaveTitle();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isEditingTitle, editedTitle]);

    const handleNotesSave = async () => {
        try {
            const data = {
                addProperty: {
                    textNotes: localNotesText,
                },
            };
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${currentTaskId}`, data);
            dispatch(updateNotesText({ taskId: taskItem.id, notesText: localNotesText }));
            setShowNotes(false);
        } catch (error) {
            console.error('Failed to update notes:', error);
        }
    };
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState('');
    const handleSelect = (subject) => {
        setSelectedLabel(subject?.subject || 'No Subject');
        setSelectedEmailData(subject?.gmailMessageId);
        handlegetEmailDetails(subject?.gmailMessageId);
        setSelectedItem(subject);
        setIsOpen(false);
    };

    const [propertyId, setPropertyId] = useState(null);

    const addProperty = async () => {
        try {
            const isUpdate = !!propertyId;

            const data = {
                property: {
                    name: propertyType?.name,
                    icon: propertyType?.icon,
                    value: null,
                    propertyName: propertyName,
                },
                boardId: location?.state?.boardId,

                isVisible: displayOnCard,
            };

            if (isUpdate) {
                const resUpdate = await services?.property?.UPDATE_PROPERTY(propertyId, data);
            } else {
                const res = await services?.property?.CREATE_PROPERTY(data);
            }

            getPropertyByID(location?.state?.boardId);
            setIsOpenDeadline(false);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    const [hoverIndex, setHoverIndex] = useState(null);

    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    const toggleDropdown = (idx, event) => {
        if (openDropdownIndex === idx) {
            setOpenDropdownIndex(null);
            setAnchorEl(null);
            setIsOpenDeadline(false);
        } else {
            setOpenDropdownIndex(idx);
            setAnchorEl(event?.currentTarget || null); // safe access
        }
    };


    const [isTypeDropdownDisabled, setIsTypeDropdownDisabled] = useState(false);
    const [disablePropertyType, setDisablePropertyType] = useState();

    const handleAddPropertyChange = (item) => {
        setPropertyType(item?.property);
        setPropertyName(item?.property?.propertyName);
        setIsTypeDropdownDisabled(true);
        setPropertyId(item?.id);
        setDisablePropertyType(item?.id);
    };
    const [openStatusIndex, setOpenStatusIndex] = useState(null);
    const handleStatusClick = (index, type) => {
        if (type == 'forceClose') {
            setOpenStatusIndex(null);
        } else {
            setOpenStatusIndex((prev) => (prev === index ? null : index));
        }
    };
    const handlePropertyDelete = async (id) => {
        if (!id) return;
        try {
            await services?.customfield.DELETE_PROPERTY(id);
            getPropertyByID(location?.state?.boardId);

            setIsOpenDeadline(false);
            setPropertyId(null);
            setPropertyName(null);
            setPropertyType(null);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    const [customPropertyId, setCustomPropertyId] = useState(null);

    const handleUpdateCell = async (item, newValue, color, idx, flag) => {
        const propertyName = item?.property?.name == 'Tag' ? 'Tag' : 'Status';
        const data = {
            customPropertyId: item?.id,
            taskId: taskItem?.id,
            customField: {
                value: newValue,
                name: item?.property?.name,
                color: color,
            },
        };

        try {
            const response = await services?.customfield.CREATE_CUSTOM_FIELD(data);

            await getPropertyByID(location?.state?.boardId);
            await getAllPropertyByTaskId(item?.id, propertyName);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const handleUpdatedCustomField = async (item, newValue, color, field, idx) => {
        const propertyName = field == 'Tag' ? 'Tag' : 'Status';
        const data = {
            customPropertyId: item?.id,
            taskId: taskItem?.id,
            customField: {
                value: newValue,
                name: item?.property?.name,
                color: color,
            },
            index: idx,
        };

        try {
            await services?.customfield.UPDATE_CUSTOM_FIELD(customeFiedId, data);

            await getPropertyByID(location?.state?.boardId);
            await getAllPropertyByTaskId(item?.id, propertyName);
            getAllProperty();
            getSingleTask(taskItem?.id);
            setCustomeFieldId(null);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const handleRemoveCustomField = async (id) => {
        const updatedTaskData = singleTaskData?.map((item) => {
            return {
                ...item,
                selectedFieldId: item?.selectedFieldId?.filter((fieldId) => fieldId !== id),
            };
        });
        handletaskUpdate(updatedTaskData);
    };

    useEffect(() => {
        getAllUser();
        getComment(taskItem?.id);
        getPropertyByID(location?.state?.boardId);
    }, []);

    const [tags, setTags] = useState(['test tag', 'hello']);
    const [input, setInput] = useState('');

    const addTag = (e) => {
        e.preventDefault();
        const value = input.trim();
        if (value && !tags.includes(value)) {
            setTags([...tags, value]);
        }
        setInput('');
    };

    const handleSelecteTag = (item, value, color, idx, flag) => {
        const propertyId = item?.id;
        const taskId = taskItem?.id;

        const finalLabel = typeof value === 'object' ? value.label : value;

        const updatedValues = [
            {
                label: finalLabel,
                color,
                flag,
            },
        ];

        const newTagObj = {
            name: 'Tag',
            value: updatedValues,
        };

        setSelectedTags((prev) => ({
            ...prev,
            [taskId]: {
                ...(prev?.[taskId] || {}),
                [propertyId]: newTagObj,
            },
        }));

        if (customeFiedId) {
            handleUpdatedCustomField(item, updatedValues, color, 'Tag', idx);
        } else {
            handleUpdateCell(item, updatedValues, color);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (propertyRef.current && !propertyRef.current.contains(event.target)) {
                setIsOpenDeadline(false);
            }
        };

        if (isOpenDeadline) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDeadline]);

    const tagModalRef = useRef();
    const isDeletingRef = useRef(false);
    useEffect(() => {
        const handleClickOutside = (e) => {
            const isClickInsideChild = tagModalRef.current?.contains(e.target);
            const isClickInsideParent = statusTagDropdownRef.current?.contains(e.target);

            if (!isClickInsideChild && isClickInsideParent) {
                setSelectedTagColor(null);
                setSelectedTagItem(null);

                setTagModalIndex(null);
                return;
            }

            if (!isClickInsideChild && !isClickInsideParent) {
                setSelectedTagColor(null);
                setSelectedTagItem(null);

                setTagModalIndex(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [selectedTagItem, tagModalIndex, inputTagValue, selectedTagColor, customeFiedId]);

    const getContrastColor = (hex) => {
        if (!hex) return '#000';
        const c = hex.replace('#', '');
        const r = parseInt(c.substr(0, 2), 16);
        const g = parseInt(c.substr(2, 2), 16);
        const b = parseInt(c.substr(4, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? '#000' : '#fff';
    };

    const [editTagName, setEditTagName] = useState();
    const deleteCustomField = async (id, idx, status, val) => {
        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);
            getSingleTask(taskItem?.id);
            getAllProperty();
            getAllPropertyByTaskId(status?.customPropertyId || status?.id, status?.customField?.name);
            setTagModalIndex(null);
            setCustomeFieldId(null);
            handleStatusClick(openStatusIndex);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const defaultColorMap = {
        Done: '#4ade80',
        'Working on': '#facc15',
        Stuck: '#f87171',
        'Waiting for approval': '#60a5fa',
        default: '#9ca3af',
    };

    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };

    const customStyles = {
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.color || '#F3F4F6',
            borderRadius: '6px',
            padding: '2px 4px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            fontSize: '0.875rem',
            color: '#111827',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#EF4444',
            ':hover': {
                backgroundColor: '#FECACA',
                color: '#B91C1C',
            },
        }),
    };
    const MultiValue = (props) => {
        const className = props.data.className || '';
        return (
            <div className={`flex items-center rounded-md px-2 py-1 mr-1 mb-1 text-[13px] ${className}`}>
                <span className="mr-1">{props.data.label}</span>
                <components.MultiValueRemove {...props}>
                    <span {...props.removeProps} className="ml-1 text-red-500 hover:text-red-700 cursor-pointer">
                        ×
                    </span>
                </components.MultiValueRemove>
            </div>
        );
    };

    const sla_alert_action = [
        {
            label: '🔥 SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 text-[10px]  bg-pink-100',
        },
        {
            label: '⚡SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 text-[10px]  bg-orange-100',
        },
    ];
    const formattedOptions = sla_alert_action.map((item) => ({
        label: `# ${item.label}`,
        value: item.value,
        className: item.color || '',
    }));
    const handleSlaTagChange = async (selectedOptions) => {
        const updatedSlaTags = selectedOptions.map((opt) => opt.value);
        let updatedTask;
        if (updatedSlaTags.length === 0) {
            updatedTask = {
                ...slaTags,
                addProperty: null,
            };
        } else {
            updatedTask = {
                ...slaTags,
                addProperty: {
                    ...(slaTags.addProperty || {}),
                    slaTags: updatedSlaTags,
                },
            };
        }
        try {
            const response = await services.task.UPDATE_TASK(updatedTask.id, updatedTask);
            const updated = response?.data?.data;
            setCurrentTask(updated);
            setSlaTags(updated);
        } catch (err) {
            console.error(':x: Failed to update SLA tags', err);
        }
    };
    const Option = (props) => {
        const { className = '', label } = props.data;
        return (
            <components.Option {...props}>
                <div className={` rounded-md px-2 py-1 w-[120px] ${className}`}>{label}</div>
            </components.Option>
        );
    };

    useEffect(() => {
        getBoardList();
        if (Array.isArray(customFieldValues)) {
            customFieldValues.forEach((field) => {
                if (field?.id) {
                    getAllPropertyByTaskId(field.id);
                }
            });
        }
    }, [taskItem?.id]);

    useEffect(() => {
        if (currentTaskId || taskItem?.boardId) {

            getSingleTask(currentTaskId, {
                "x-user-id": userData?.id,
                "x-user-name": userData?.name,
                "x-socket-id": gmailSocket.id,
            });
            getAllProperty();
        }
    }, [taskItem?.boardId, taskItem?.id]);

    useEffect(() => {
        if (isOpenDeadline) {
            setOpenDropdownIndex(null);
        }
    }, [isOpenDeadline]);

    function findBySelectedPropId(id, customProperty) {
        return customProperty.find((item) => item.selectedPropId === id);
    }

    const updateCustomProKey = (item, fieldId, newSelected) => {
        const propertyName = item?.property?.name;

        if (!propertyName) return;
        let updated = [...customprokey];
        const obj = findBySelectedPropId(item.id, updated);

        if (propertyName === 'Tag') {
            const idArray = newSelected.map((item) => item.id);
            if (obj?.selectedPropId) {
                updated.map((itemobj) => {
                    if (itemobj.selectedPropId == obj.selectedPropId) {
                        itemobj.selectedFieldId = idArray;
                    }
                    return itemobj;
                });
            } else {
                updated.push({
                    selectedPropId: item.id,
                    selectedFieldId: idArray,
                });
            }
        } else if (propertyName === 'Status') {
            if (obj?.selectedPropId) {
                updated.map((itemobj) => {
                    if (itemobj.selectedPropId == obj.selectedPropId) {
                        itemobj.selectedFieldId = [fieldId];
                    }
                    return itemobj;
                });
            } else {
                updated.push({
                    selectedPropId: item.id,
                    selectedFieldId: [fieldId],
                });
            }
        }
        setCustomprokey(updated);

        setTriggerTaskUpdate(true);
        handletaskUpdate(updated);
    };

    const handletaskUpdate = async (customProperty) => {
        let obj = [...customprokey];
        if (customProperty) {
            obj = [...customProperty];
        }

        const data = {
            customProperty: obj,
        };

        try {
            const response = await services.task.UPDATE_TASK(taskItem?.id, data);
            const updatedProperties = response?.data?.data?.customProperty ?? [];
            getSingleTask(taskItem?.id);
            getAllProperty();
            setCustomprokey(updatedProperties);
            for (const prop of updatedProperties) {
                if (prop.selectedPropId) {
                    await getAllPropertyByTaskId(prop.selectedPropId, '', updatedProperties);
                }
            }
        } catch (err) {
            console.error('Failed to update SLA tags', err);
        }
    };

    const getTagLabelByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value?.[0]?.label || null;
    };

    const getTagLabelColorByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);

        return matchedItem?.customField?.value?.[0]?.color || null;
    };

    const getTagLabelByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value || null;
    };

    const getTagLabelColorByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.color || null;
    };

    function stripTags(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }
    function highlightMentions(text) {
        return text
            .split(/(\s+)/)
            .map((word, i) =>
                word.startsWith('@') ? `<span style="color:#1CA7EC;font-weight:bold;">${word}</span>` : word,
            )
            .join('');
    }
    const handleUploadTaskAttachmentFileChange = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        setUploadTaskAttachment((prev) => [...prev, ...selectedFiles]);

        const formData = new FormData();
        selectedFiles.forEach((file, index) => {
            formData.append('attachments', file);
        });

        try {
            await services.task.UPDATE_TASK(taskItem?.id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            getSingleTask(taskItem?.id)
        } catch (error) {
            console.error('Upload failed', error);
        }
        e.target.value = '';
    };


    const dropattachmentRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropattachmentRef.current && !dropattachmentRef.current.contains(event.target)) {
                setOpenIndex();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openIndex]);

    const handleClickAttachFile = () => {
        attachmentUploadRef.current.click();
    };


    const deleteAttachementFile = async (attachmentId) => {


        try {
            const response = await services.task.DELETE_TASK_ATTACHEMENT(taskItem?.id, attachmentId);

            if (response?.status == 200) {
                toast.success(response?.data?.message)
                getSingleTask(taskItem?.id)
                setOpenIndex(null)
            }
        } catch (error) {
            console.error('Upload failed', error);
        }
    }
    const [showArchiveConfirmation, setShowArchiveConfirmation] = useState(false);
    const archiveTask = async (item) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${item?.id}`, {
                isInComplete: true,
            });

            if (response && item?.boardId) {
                toast.success('Task archived successfully');
                navigate('/app', { state: { boardName: boardName } })
            }
        } catch (error) {
            console.error('Error archiving task:', error);
            if (error.response && error.response.data && error.response.data.message) {
                let taskNames = error.response.data.error.replace(/^Error updating Task:\s*/, "");


                toast.error(taskNames);
            } else {
                toast.error('Failed to archive task');
            }
        }
    };

    const handleArchiveClick = (item) => {

        setShowArchiveConfirmation(true);
    };

    const handleConfirmArchive = () => {
        archiveTask(taskItem);
        setShowArchiveConfirmation(false);
    };

    const handleCancelArchive = () => {
        setShowArchiveConfirmation(false);
    };
    const [draggingItem, setDraggingItem] = useState({ id: null, index: null });

    const handleDragStart = (item, index) => {
        setDraggingItem({ id: item.id, index });
        // setDraggingIndex(index)
    };
    const handleDragOver = (e) => e.preventDefault();
    const handleDrop = async (dropIndex, item) => {
        if (!draggingItem) return;
        const data = {
            boardId: item?.boardId,
            index: dropIndex
        }
        const response = await services.property.UPDATE_PROPERTY_BY_POSITION(draggingItem?.id, data);
        if (response?.status === 200) {
            getPropertyByID(item?.boardId)
        }
        setDraggingItem({ id: null, index: null });
    };
    const [showTripList, setShowTripList] = useState(false);

    const handleCloseTripList = () => setShowTripList(false);
    const handleShowTripList = () => { fetchTaskTripIds(); setShowTripList(true) };
    const getUserInitials = (name = "") => {
        if (!name || typeof name !== "string") return "U";

        const firstChar = name
            .trim()
            .replace(/[^a-zA-Z]/g, "")
            .charAt(0);

        return firstChar ? firstChar.toUpperCase() : "U";
    };

    const toTitleCase = (name = "") => {
        if (!name || typeof name !== "string") return "User";

        return name
            .toLowerCase()
            .split(" ")
            .filter(Boolean)
            .map(
                word => word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    };

    const handleCreateNewTrip = () => {
        const parentUrl = parentOrigin + "/tripboard";
        const newWin = window.open(parentUrl, "_blank");

        const payload = {
            type: "TASK_DATA",
            taskId: { currentTaskId, boardId: boardID, columnId: columnID },
            fromTask: true
        };

        const sendWhenReady = (event) => {
            if (
                event.source === newWin &&
                event.data === "READY_FOR_TASK_DATA"
            ) {
                newWin.postMessage(payload, parentOrigin);
                window.removeEventListener("message", sendWhenReady);
            }
        };

        window.addEventListener("message", sendWhenReady);
        setConfimationModal(false);
    };


    const handleCloneTrip = () => {
        const parentUrl = parentOrigin + "/trip";
        const newWin = window.open(parentUrl, "_blank");

        const payload = {
            type: "CLONE_DATA",
            taskId: { currentTaskId, title: editedTitle || taskItem?.title, boardId: boardID, columnId: columnID },
            fromTask: true
        };
        const sendWhenReady = (event) => {
            if (
                event.source === newWin &&
                event.data === "READY_FOR_CLONE_DATA"
            ) {
                newWin.postMessage(payload, parentOrigin);
                window.removeEventListener("message", sendWhenReady);
            }
        };

        window.addEventListener("message", sendWhenReady);
        setConfimationModal(false);

    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openActionMenu !== null) {
                // Check if click is outside dropdown and button
                const dropdownElement = document.querySelector(".dropdown-menu.show");
                const buttonElement = actionButtonRefs.current[openActionMenu];

                if (
                    dropdownElement &&
                    !dropdownElement.contains(event.target) &&
                    buttonElement &&
                    !buttonElement.contains(event.target)
                ) {
                    setOpenActionMenu(null);
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openActionMenu]);
    return (
        <>
            <div className={`w-full h-full ${taskDetailsModal ? 'fixed top-0  h-[91vh]  left-[78vw] z-50' : ''}`}>
                <div
                    className={`bg-white rounded-md relative px-3  ${taskDetailsModal ? 'h-full w-[22vw]' : 'h-full'
                        }  md:max-w-[30vw] flex flex-col justify-between `}
                >
                    <div
                        style={{ padding: '3% 0' }}
                        className="flex flex-row items-center gap-1 sticky top-0 left-0 bg-white justify-between z-30 w-full bg-white border rounded-md shadow-[0px_1px_3px_0px_rgba(0,0,0,0.02),_0px_0px_0px_1px_rgba(27,31,35,0.15)]"
                    >
                        <div className="flex flex-row items-center gap-1 ">
                            <span
                                style={{ border: "2px solid #0000008c" }}
                                className=" ms-1 circle-user cursor-pointer mr-1 flex items-center justify-center  rounded-full hover:bg-gray-100"
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleArchiveClick(item);
                                    }}
                                >
                                    <path
                                        d="M7.75 12.0001L10.58 14.8301L16.25 9.17012"
                                        stroke="#7d7d7d"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>

                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Add a Reminder"
                                onClick={() => {
                                    setShowReminderMeDropdown(!showReminderMeDropdown);
                                    setShowMyDayPlanDropdown(false);
                                    setShowMyDeadlinDropdown(false);
                                    setClickedIcon('bell');
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-bell"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Add to My Day plan"
                                onClick={() => {
                                    setShowMyDayPlanDropdown(!showMyDayPlanDropdown);
                                    setShowMyDeadlinDropdown(false);
                                    setClickedIcon('calendarIcon');
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-calendar-date"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Update a deadline"
                                onClick={() => {
                                    {
                                        setShowMyDeadlinDropdown(!showMyDeadlineDropdown), setClickedIcon('flagIcon');
                                        setShowMyDayPlanDropdown(false);
                                    }
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-flag"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Attach File"
                            >
                                <label htmlFor="file-upload" className="cursor-pointer flex items-center justify-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="currentColor"
                                        viewBox="0 0 22 22"
                                    >
                                        <path d="M16.5 6.75v7.5a4.5 4.5 0 1 1-9 0V5.25a3.75 3.75 0 1 1 7.5 0v8.25a2.25 2.25 0 1 1-4.5 0V7.5h1.5v6a.75.75 0 0 0 1.5 0V5.25a2.25 2.25 0 0 0-4.5 0v9a3.75 3.75 0 1 0 7.5 0v-7.5z" />
                                    </svg>
                                </label>

                                <input
                                    id="file-upload"
                                    type="file"
                                    ref={attachmentUploadRef}
                                    multiple
                                    accept="image/*"
                                    className="hidden"
                                    onClick={() => { attachmentUploadRef.current.value = null; }}
                                    onChange={(e) => { handleUploadTaskAttachmentFileChange(e) }}
                                />
                            </span>



                            <input
                                type="file"
                                accept=".pdf,.txt,.jpg,.jpeg,.png,.gif"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Compose"
                                onClick={() => setComposeStatus(true)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zm2.75-1.25A1.25 1.25 0 0 0 3.5 6.75v.217l8.5 5.1 8.5-5.1V6.75A1.25 1.25 0 0 0 19.25 5.5zm16.75 2.383-8.19 4.914a.75.75 0 0 0-.82 0L3.5 7.883V17.25c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25z" />
                                </svg>
                            </span>
                            {PrivilegesChecker("trip") && (<>
                                <span className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer" title="Add Trip">
                                    <button
                                        className="primary-btn d-flex gap-2 align-items-center"
                                        style={{ padding: '0.25rem 0.5rem', fontSize: '0.875rem', whiteSpace: 'nowrap' }}
                                        onClick={() => {
                                            setConfimationModal(true);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="27"
                                            height="27"
                                            viewBox="0 0 60 61"
                                            fill="none"
                                        >
                                            <path
                                                d="M30 55.5C43.8071 55.5 55 44.3071 55 30.5C55 16.6929 43.8071 5.5 30 5.5C16.1929 5.5 5 16.6929 5 30.5C5 44.3071 16.1929 55.5 30 55.5Z"
                                                stroke="#96A0B5"
                                                stroke-width="3.75"
                                            />
                                            <path
                                                d="M37.5 30.5H30M30 30.5H22.5M30 30.5V23M30 30.5V38"
                                                stroke="#96A0B5"
                                                stroke-width="3.75"
                                                stroke-linecap="round"
                                            />
                                        </svg>
                                    </button>


                                </span>
                                <span onClick={handleShowTripList} className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer" title="Trip List">
                                    <button
                                        className="dropdown-item d-flex align-items-center"
                                    >
                                        <svg width="27" height="27" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                            <path d="M264 112L376 112C380.4 112 384 115.6 384 120L384 160L256 160L256 120C256 115.6 259.6 112 264 112zM208 120L208 544L432 544L432 120C432 89.1 406.9 64 376 64L264 64C233.1 64 208 89.1 208 120zM480 160L480 544L512 544C547.3 544 576 515.3 576 480L576 224C576 188.7 547.3 160 512 160L480 160zM160 544L160 160L128 160C92.7 160 64 188.7 64 224L64 480C64 515.3 92.7 544 128 544L160 544z" stroke="#96A0B5" stroke-width="3.75" fill="#96A0B5" />
                                        </svg>

                                    </button>
                                </span>
                            </>
                            )}
                        </div>

                        <div>
                            <button
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                onClick={taskDetailsModal ? () => { fetchTaskTripIds(), setTaskDetailModal(false) } : () => navigate(-1)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414" />
                                </svg>
                            </button>
                        </div>



                    </div>

                    <div className="flex-1 overflow-y-auto">
                        <div
                            className="w-full overflow-y-auto overflow-x-hidden "
                            style={{
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                maxHeight: '100%',
                            }}
                        >
                            <div className="flex justify-between items-center pb-[5px]  border-b border-[#e0e0e0]">
                                <div className="flex-1">
                                    {isEditingTitle ? (
                                        <input
                                            ref={titleInputRef}
                                            className="text-[1.2rem] font-bold text-black mt-[10px] text-start border rounded px-2 py-1 w-full"
                                            value={editedTitle}
                                            autoFocus
                                            onChange={(e) => setEditedTitle(e.target.value)}
                                        />
                                    ) : (
                                        <h3 className="text-[1.2rem] w-full max-w-[20vw] font-bold text-black mt-[10px] text-start truncate">
                                            {editedTitle
                                                ? editedTitle
                                                : taskItem?.title
                                                    ? taskItem?.title
                                                    : taskItem?.subject}
                                        </h3>
                                    )}
                                </div>
                                <FiEdit onClick={() => setIsEditingTitle(!isEditingTitle)} />
                            </div>

                            <div className="w-full p-[6px] mt-2">
                                {threadMergedArray && threadMergedArray.length > 1 ? (
                                    <div className="flex items-center justify-between border rounded-md px-3 h-[40px] w-full relative">
                                        <div
                                            className="flex items-center gap-2 text-sm text-[#333] w-full overflow-hidden cursor-pointer"
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            <i className="fas fa-envelope-open-text text-[#555]" />
                                            <span className="truncate">
                                                {selectedLabel ? selectedLabel : 'Email Group : Change Email thread'}
                                            </span>
                                        </div>

                                        <div className="h-[24px] w-[1px] bg-gray-300 mx-2"></div>

                                        <button
                                            className="flex-shrink-0"
                                            onClick={() => handlegetEmailDetails(selectedUserId)}
                                        >
                                            <i className="fas fa-sync text-sm text-[#666] hover:text-black" />
                                        </button>

                                        {isOpen && (
                                            <div
                                                className="absolute top-[42px] left-0 w-full bg-white border rounded-md shadow-md z-10 max-h-60 overflow-y-auto"
                                                style={{ maxWidth: '70%' }}
                                            >
                                                {threadMergedArray?.map(
                                                    (subject, index) =>
                                                        subject && (
                                                            <div
                                                                key={subject.id || index}
                                                                className={`text-sm text-gray-800 p-2 cursor-pointer hover:bg-gray-100 ${selectedItem?.id === subject.id ? 'bg-gray-200' : ''
                                                                    }`}
                                                                onClick={() => handleSelect(subject)}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <span>
                                                                        {subject?.subject?.length > 30
                                                                            ? subject.subject.slice(0, 30) + '...'
                                                                            : subject?.subject || 'No Subject'}
                                                                    </span>
                                                                    <span className="text-gray-500 ml-4">
                                                                        {new Date(subject?.createdAt).toLocaleString(
                                                                            'en-US',
                                                                            {
                                                                                month: 'short',
                                                                                day: 'numeric',
                                                                            },
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ),
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <button className="border-2 rounded w-full h-[40px] text-[#A2A2A2] text-sm">
                                        Open Email thread
                                    </button>
                                )}
                            </div>

                            <div className="relative">
                                <div className="flex gap-x-[0.5vw] justify-between items-center py-[1vw]">
                                    <button
                                        className="text-[12px] p-2 font-medium p-[3px_84px_2px] bg-[#8BC34A] rounded-[4px] text-[#fff] w-full p-[10px]"
                                        onClick={() => setIsOpenProjectBoard(!isOpenProjectBoard)}
                                        style={{ backgroundColor: selectedBoardColor || '#8BC34A' }}
                                    >
                                        {selectedBoard == null
                                            ? 'Choose Board'
                                            : `${selectedBoard}-${selectedColumnName}`}
                                    </button>
                                </div>
                                <div>
                                    {isOpenProjectBoard && (
                                        <div className="absolute right-0 mt-2 w-64 bg-white border rounded shadow-lg z-30">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="w-full px-4 py-2 border-b focus:outline-none"
                                            />
                                            <div className="p-1 overflow-y-auto max-h-60">
                                                <ul className="mt-1 list-none" style={{ padding: 0 }}>
                                                    {filteredBoards && filteredBoards.length > 0 ? (
                                                        filteredBoards.map((board) => (
                                                            <div key={board.id}>
                                                                <li className="border-b-2 uppercase text-[11px] text-black font-bold px-4 pt-3 pb-1 border-t first:border-none text-left">
                                                                    {board.boardName}
                                                                </li>
                                                                {board.BoardLists && board.BoardLists.length > 0 && (
                                                                    <div>
                                                                        {board.BoardLists.map((col) => (
                                                                            <li
                                                                                key={col.id}
                                                                                onClick={() =>
                                                                                    handleBoardChange(board, col)
                                                                                }
                                                                                className="px-4 py-2 hover:bg-gray-100 text-gray-800 cursor-pointer text-sm text-left"
                                                                            >
                                                                                {col.coloum}
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <li className="px-4 py-2 text-gray-400">No boards found</li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="flex items-center py-[0.8vw] "
                                    onClick={() => {
                                        if (isDisabled) toast.error('Please select a board first');
                                    }}
                                >
                                    <div className="w-[100%]">
                                        <div className="py-[0.8vw]">
                                            <div className="flex  border-b border-[#f5f5f5] items-center gap-x-[10px]">
                                                <div className="flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-person-circle"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                                                    </svg>
                                                </div>
                                                <AssignDropdown
                                                    selectedMail={selectedMail}
                                                    currentTaskId={currentTaskId}
                                                    taskAssign={taskAssign}
                                                    handleAssign={handleAssign}
                                                    handleInputChange={handleInputChange}
                                                    handleClearAssignment={handleClearAssignment}
                                                    taskItem={taskItem}
                                                    onClose={() => setIsSearchBoxOpen(false)}
                                                    selectedBoardId={taskItem?.boardId}
                                                />
                                            </div>
                                        </div>
                                        <div className="relative inline-block text-left" ref={dropdownRef}>
                                            <div
                                                className=" border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                                style={{ padding: '9px 0' }}
                                            >
                                                <div className=" flex items-center ">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-bell"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                                    </svg>
                                                </div>
                                                <button
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                    onClick={() => {
                                                        setShowReminderMeDropdown(!showReminderMeDropdown),
                                                            setClickedIcon(null);
                                                    }}
                                                >
                                                    {selectedReminderDate
                                                        ? formatDateForDisplay(selectedReminderDate)
                                                        : 'Reminder...'}
                                                </button>
                                            </div>

                                            {showReminderMeDropdown && (
                                                <ReminderMe
                                                    selectedReminderDate={selectedReminderDate}
                                                    updateSelectedReminderDate={updateSelectedReminderDate}
                                                    updateSelectedStatusNextStepDate={updateSelectedStatusNextStepDate}
                                                    updateMyDayDate={updateMyDayDate}
                                                    updateDeadlineDate={updateDeadlineDate}
                                                    handleReminderChange={handleReminderChange}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    setIsReminder={setIsReminder}
                                                    taskItem={taskItem}
                                                    clickedBellIcon={clickedBellIcon}
                                                    setShowReminderMeDropdown={setShowReminderMeDropdown}
                                                >
                                                    <DatePicker
                                                        selected={
                                                            selectedReminderDate ? new Date(selectedReminderDate) : null
                                                        }
                                                        onChange={(date) => updateSelectedReminderDate(date)}
                                                    />
                                                </ReminderMe>
                                            )}
                                        </div>
                                        <div
                                            className="border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                            style={{ padding: '9px 0' }}
                                        >
                                            <div className=" flex items-center gap-x-[10px]] ">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-calendar-date"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                                </svg>
                                            </div>
                                            <div className="relative inline-block text-left" ref={myDayPlanDropdownRef}>
                                                <button
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                    onClick={() => {
                                                        setShowMyDayPlanDropdown(!showMyDayPlanDropdown);
                                                        setClickedIcon(null);
                                                        setShowMyDeadlinDropdown(false);
                                                    }}
                                                >
                                                    {myDayDate ? formatDateForDisplay(myDayDate) : 'My Day plan...'}
                                                </button>
                                                {showMyDayPlanDropdown && (
                                                    <div className="deadline-dropdown">
                                                        <MyDayPlanDropdown
                                                            setSelectedMyDayPlanDate={updateSelectedMyDayPlanDate}
                                                            selectedMyDayPlanDate={selectedMyDayPlanDate}
                                                            handleUpdateTask={handleUpdateTaskWrapper}
                                                            isOpen={showMyDayPlanDropdown}
                                                            taskItem={taskItem}
                                                            currentTaskId={currentTaskId}
                                                            onClose={() => setShowMyDayPlanDropdown(false)}
                                                            getTaskMail={getTaskMail}
                                                            handleDateSelect={handleDateSelectWrapper}
                                                            setIsMyDayChecked={updateIsMyDayChecked}
                                                            isMyDayChecked={isMyDayChecked}
                                                            clickedBellIcon={clickedBellIcon}
                                                            selectedBoardId={selectedBoardId}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            className=" border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                            style={{ padding: '9px 0' }}
                                        >
                                            <div className=" flex items-center gap-x-[10px]]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-flag"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                                </svg>
                                            </div>

                                            <button
                                                className="relative text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                onClick={() => {
                                                    {
                                                        setShowMyDeadlinDropdown(!showMyDeadlineDropdown),
                                                            setClickedIcon(null);
                                                        setShowMyDayPlanDropdown(false);
                                                    }
                                                }}
                                            >
                                                {deadlineDate ? formatDateForDisplay(deadlineDate) : 'Deadline...'}
                                            </button>

                                            {showMyDeadlineDropdown && (
                                                <div className="relative deadline-dropdown">
                                                    <TaskDeadline
                                                        currentTaskId={currentTaskId}
                                                        setSelectedMyDayPlanDate={updateSelectedMyDayPlanDate}
                                                        selectedMyDayPlanDate={selectedMyDayPlanDate}
                                                        deadlineDate={deadlineDate}
                                                        handleUpdateTask={handleUpdateTaskWrapper}
                                                        taskItem={taskItem}
                                                        isOpen={showMyDeadlineDropdown}
                                                        onClose={() => setShowMyDeadlinDropdown(false)}
                                                        getTaskMail={getTaskMail}
                                                        handleDateSelect={handleDateSelectWrapper}
                                                        isDeadlineChecked={isDeadlineChecked}
                                                        setIsDeadlineChecked={updateIsDeadlineChecked}
                                                        clickedBellIcon={clickedBellIcon}
                                                    />
                                                </div>
                                            )}
                                        </div>


                                        {/* <div className="border-b py-[0.8vw] border-[#f5f5f5] flex items-start gap-x-[10px]"
                                            style={{ padding: '9px 0' }}>
                                            <div className="flex items-center gap-x-[10px]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-list"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                                </svg>
                                            </div>
                                            {/* <button
                                                className="relative text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                              
                                            >
                                                {'Add Trip'}
                                            </button>
                                        </div> */}
                                        <div
                                            className="border-b py-[0.8vw] border-[#f5f5f5] flex items-start gap-x-[10px]"
                                            style={{ padding: '9px 0' }}
                                        >
                                            <div className="flex items-center gap-x-[10px]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-list"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                                </svg>
                                            </div>

                                            {!showNotes && (
                                                <button
                                                    onClick={() => setShowNotes(true)}
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                >
                                                    {localNotesText || 'Notes (Shift-Enter for new line)...'}
                                                </button>
                                            )}

                                            {showNotes && (
                                                <div
                                                    ref={notesRef}
                                                    style={{
                                                        position: 'relative',
                                                        right: 0,
                                                        p: 2,
                                                        bgcolor: 'background.body',
                                                        top: '20%',
                                                        width: '100%',
                                                        maxWidth: '85%',
                                                    }}
                                                >
                                                    <TextField
                                                        fullWidth
                                                        value={localNotesText}
                                                        onChange={(e) => setLocalNotesText(e.target.value)}
                                                        onBlur={handleNotesSave}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                handleNotesSave();
                                                            }
                                                        }}
                                                        id="standard-multiline-static"
                                                        multiline
                                                        rows={4}
                                                        variant="standard"
                                                        sx={{
                                                            '& .MuiInputBase-root': {
                                                                padding: 0,
                                                            },
                                                            '& .MuiInput-input': {
                                                                padding: 0,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {showNotes ? (
                                            <div className="h-[36px] border-b border-[#f5f5f5] flex items-center gap-x-[10px]">
                                                <div className="h-[36px] flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                                                    </svg>
                                                </div>
                                                <a href="#" className="text-listdrop !text-[13px]">
                                                    Next Step...
                                                </a>
                                            </div>
                                        ) : (
                                            <div className="h-[36px] border-b border-[#f5f5f5] flex items-center gap-x-[10px]">
                                                <div className="h-[36px] flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                                                    </svg>
                                                </div>

                                                <TaskStatusNextStep
                                                    note={note}
                                                    handleChange={handleReminderChange}
                                                    setSelectedStatusNextStepDate={updateSelectedStatusNextStepDate}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    selectedReminderDate={selectedReminderDate}
                                                    isReminder={isReminder}
                                                    selectedStatusNextStepDate={selectedStatusNextStepDate}
                                                    taskItem={taskItem}
                                                    setSelectedReminderDate={updateSelectedReminderDate}
                                                    getTaskMail={getTaskMail}
                                                    nextStepNote={nextStepNote}
                                                    currentTaskId={currentTaskId}
                                                />
                                            </div>
                                        )}
                                        <div className="">
                                            {taskMail?.map((item) => {
                                                return (
                                                    <>
                                                        <div className="relative h-[36px] flex justify-between border-b border-[#f5f5f5]  items-center gap-x-[10px]">
                                                            <a href="#" className="text-listdrop !text-[13px]">
                                                                {item?.type}
                                                            </a>
                                                            <div>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-trash"
                                                                    viewBox="0 0 16 16"
                                                                    onClick={() =>
                                                                        deleteTaskMailProperty(
                                                                            item?.type,
                                                                            item?.propertyName,
                                                                            item?.id,
                                                                        )
                                                                    }
                                                                >
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>

                                        {slaTags?.addProperty?.slaTags?.length > 0 && (
                                            <div>
                                                <div className=" border-b border-[#F5F5F5]  items-center gap-x-[10px]">
                                                    <div className="flex items-center gap-[10px]">
                                                        <LiaTagsSolid />
                                                        <div className="text-listdrop !text-[13px]">SLA Alerts...</div>
                                                    </div>

                                                    <Select
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={formattedOptions}
                                                        value={formattedOptions.filter((item) =>
                                                            (slaTags?.addProperty?.slaTags || []).includes(item.value),
                                                        )}
                                                        onChange={handleSlaTagChange}
                                                        placeholder="Choose SLA alerts..."
                                                        className="!text-[12px]"
                                                        styles={customStyles}
                                                        components={{
                                                            MultiValue,
                                                            MultiValueRemove: () => null,
                                                            Option,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {isOpenDeadline && (
                                            <div
                                                className={`dropdown ${isOpenDeadline ? 'open' : ''
                                                    } deadline-day deadend-start kanban-dropDown bg-white !absolute bottom-[0vw] !left-0 rounded-md shadow-md p-2 `}
                                                ref={propertyRef}
                                            >
                                                <div className="flex justify-between items-center mb-2">
                                                    <h2 className="text-sm font-semibold text-black">
                                                        Property Settings
                                                    </h2>
                                                    <div className="flex gap-2">
                                                        <button className="text-gray-600 hover:text-gray-800">
                                                            <i className="bi bi-check-circle-fill text-[16px]"></i>
                                                        </button>

                                                        <button
                                                            style={{
                                                                borderRadius: '4px',
                                                                color: 'black',
                                                                fontSize: '13px',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                handlePropertyDelete(propertyId);
                                                                setIsOpenDeadline(false);
                                                            }}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="mb-2">
                                                    <label
                                                        htmlFor="propertyType"
                                                        className="block text-gray-700 text-xs font-semibold mb-1 text-start"
                                                    >
                                                        Type
                                                    </label>
                                                    <select
                                                        id="propertyType"
                                                        className="border border-gray-300 rounded-md w-full py-1.5 px-2 text-sm text-gray-700 focus:outline-none focus:ring focus:border-blue-300"
                                                        value={propertyType?.name}
                                                        onChange={handlePropertyTypeChange}
                                                        style={{ backgroundColor: 'white' }}
                                                    >
                                                        <option value="">Select type</option>
                                                        {propertyTypes?.map((item, index) => (
                                                            <option key={index} value={item.name}>
                                                                {item.icon} {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="mb-2">
                                                    <label
                                                        htmlFor="propertyName"
                                                        className="block text-gray-700 text-xs font-semibold mb-1 text-start"
                                                    >
                                                        Property Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="propertyName"
                                                        className="border border-gray-300 rounded-md w-full py-1.5 px-2 text-sm text-gray-700 focus:outline-none focus:ring focus:border-blue-300"
                                                        value={propertyName}
                                                        onChange={handlePropertyNameChange}
                                                        onKeyDown={handleKeyDown}
                                                        placeholder="Add property name here"
                                                        style={{ backgroundColor: 'white' }}
                                                    />
                                                </div>

                                                <div
                                                    className="mb-2 flex items-start "
                                                    style={{ alignItems: 'center' }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="displayOnCard"
                                                        className="mt-1 form-checkbox text-blue-600"
                                                        checked={displayOnCard}
                                                        onChange={handleDisplayOnCardChange}
                                                        style={{ backgroundColor: 'white' }}
                                                    />
                                                    <label
                                                        htmlFor="displayOnCard"
                                                        className="ml-2 text-gray-700 text-[11px] font-medium leading-tight"
                                                    >
                                                        Display on Card{' '}
                                                        <span className="text-gray-500">
                                                            (available on tags + statuses)
                                                        </span>
                                                    </label>
                                                </div>

                                                <div className="flex justify-end gap-2 mt-2">
                                                    <button
                                                        className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-300 transition-colors"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            setIsOpenDeadline(false);
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={addProperty}
                                                        disabled={propertyType?.name === '' && propertyName === ''}
                                                        className={`text-white text-xs px-3 py-1.5 rounded-md transition-colors
                                                                  ${propertyType?.name === '' && propertyName === ''
                                                                ? 'bg-gray-300 cursor-not-allowed'
                                                                : 'bg-blue-500 hover:bg-blue-600'
                                                            } `}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div className="    flex items-center gap-x-[10px] bg-[#eee]">
                                            <div className=" flex items-center gap-x-[10px]] w-100 flex-column">
                                                {addPropertyData?.map((item, idx) => {
                                                    const propertyId = item?.id;

                                                    const matchedField = Array.isArray(customFieldValues)
                                                        ? customFieldValues.find(
                                                            (field) => field.customPropertyId == propertyId,
                                                        )
                                                        : null;

                                                    const matchedTagField = Array.isArray(customFieldValues)
                                                        ? customFieldValues.find(
                                                            (field) => field?.customPropertyId === propertyId,
                                                        )
                                                        : null;
                                                    const fieldValue =
                                                        statusValues[propertyId] ||
                                                        matchedField?.customField?.value ||
                                                        '';

                                                    const tagValue =
                                                        selectedTags[propertyId] || matchedTagField?.customField?.value;

                                                    const filterTagProperty = filterTagValue?.filter(
                                                        (item) => item?.customPropertyId == propertyId,
                                                    );
                                                    const defaultTagValues = defaultTags;
                                                    const tagFieldsData =
                                                        customFieldValues?.filter(
                                                            (item) => item?.customField?.name === 'Tag',
                                                        ) || [];

                                                    const existingTagValues = new Set();

                                                    tagFieldsData.forEach((item) => {
                                                        const values = Array.isArray(item?.customField?.value)
                                                            ? item.customField.value
                                                            : [];
                                                        values.forEach((val) => existingTagValues.add(val));
                                                    });

                                                    defaultTagValues.forEach((defaultValue) => {
                                                        if (!existingTagValues.has(defaultValue)) {
                                                            tagFieldsData.push({
                                                                id: defaultValue?.id,
                                                                customField: {
                                                                    name: 'Tag',
                                                                    value: [defaultValue?.customField?.value],
                                                                },
                                                            });
                                                            existingTagValues.add(defaultValue);
                                                        }
                                                    });

                                                    const matchedItem =
                                                        singleTaskData &&
                                                        singleTaskData?.find(
                                                            (ele) => ele?.selectedPropId === propertyId,
                                                        );

                                                    const selectedFieldId = matchedItem
                                                        ? matchedItem.selectedFieldId
                                                        : [];
                                                    const filteredFieldDetails = allCustomFieldList.filter(
                                                        (ele) => ele.customPropertyId == propertyId,
                                                    );

                                                    const renderFieldValue = () => {
                                                        if (item?.property?.name === 'Tag') {
                                                            return <div className="flex flex-wrap gap-1 mt-1"></div>;
                                                        }

                                                        return (
                                                            <span
                                                                className="text-gray-700 ml-2"
                                                                style={{
                                                                    fontSize: '12px',
                                                                    color: '#2094f3',
                                                                    backgroundColor: '#e7f3fe',
                                                                    borderColor: '#64b5f7',
                                                                    padding: '10px',
                                                                    borderRadius: '3px',
                                                                    paddingBottom: '2px',
                                                                    paddingTop: '0',
                                                                }}
                                                            >
                                                                {tagValue}
                                                            </span>
                                                        );
                                                    };

                                                    return (
                                                        <div
                                                            key={idx}
                                                            className="pb-2 w-100 bg-[#fff]   "
                                                            style={{ borderBottom: '1px solid #eee' }}
                                                        >
                                                            <div
                                                                key={item.id}
                                                                draggable
                                                                onMouseEnter={() => setHoverIndex(idx)}
                                                                onDragStart={() => handleDragStart(item, idx)}    // pass both item & index
                                                                onDragOver={handleDragOver}                       // allow drop
                                                                onDrop={() => handleDrop(idx, item)}              // pass target item & index
                                                                onDragEnd={() => setDraggingItem({ id: null, index: null })}
                                                                className={`flex justify-content-between align-items-center w-100 gap-2 items-center relative p-2 transition-all duration-150 ${draggingItem.id === item.id ? "opacity-50 bg-blue-50" : ""
                                                                    }`}
                                                            >
                                                                <div
                                                                    className="flex gap-2 w-100"
                                                                    onClick={() => {
                                                                        if (item?.property?.name === 'Status') {
                                                                            handleStatusClick(idx);

                                                                            getAllPropertyByTaskId(
                                                                                item?.id,
                                                                                item?.property?.name,
                                                                            );

                                                                            setShowOptionModal(null);
                                                                        } else if (item?.property?.name === 'Tag') {
                                                                            getSingleTask(taskItem?.id);
                                                                            handleStatusClick(idx);
                                                                            getAllPropertyByTaskId(
                                                                                item?.id,
                                                                                item?.property?.name,
                                                                            );

                                                                            setShowOptionModal(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    <span
                                                                        className={`${item?.property?.name === 'Tag' &&
                                                                            (!fieldValue || fieldValue.length === 0)
                                                                            ? 'text-gray-400'
                                                                            : ''
                                                                            }  inline-block`}
                                                                        style={{ fontSize: '9px' }}
                                                                    >
                                                                        {item?.property?.icon}
                                                                    </span>

                                                                    <span className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer">
                                                                        {item?.property?.propertyName ||
                                                                            item?.property?.fieldType}
                                                                    </span>
                                                                </div>

                                                                {hoverIndex === idx && (
                                                                    <span
                                                                        className="cursor-pointer"
                                                                        onClick={() => {
                                                                            handleStatusClick(idx, 'forceClose');
                                                                            toggleDropdown(idx);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="16"
                                                                            height="16"
                                                                            fill="currentColor"
                                                                            className="bi bi-caret-down-circle"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                                                            <path d="M3.7 6.7a1 1 0 0 1 1.4 0L8 9.6l2.9-2.9a1 1 0 1 1 1.4 1.4l-3.6 3.6a1 1 0 0 1-1.4 0l-3.6-3.6a1 1 0 0 1 0-1.4z" />
                                                                        </svg>
                                                                    </span>
                                                                )}

                                                                {openDropdownIndex === idx && (
                                                                    <div
                                                                        ref={propertyRef}
                                                                        className="absolute z-10 bg-white shadow-md rounded px-1 py-1 text-sm mt-2 w-full"
                                                                        style={{ right: '0' }}
                                                                    >
                                                                        <div className="hover:bg-gray-100 cursor-pointer px-2 py-1 rounded d-flex align-items-center justify-content-between">
                                                                            <span
                                                                                onClick={(event) => {
                                                                                    handleAddPropertyChange(item);

                                                                                    setIsOpenDeadline(true);
                                                                                }}
                                                                            >
                                                                                {' '}
                                                                                <i className="bi bi-gear me-2"></i>{' '}
                                                                                Property Settings
                                                                            </span>{' '}
                                                                            <img
                                                                                src="/assets/cross.svg"
                                                                                style={{
                                                                                    width: '16px',
                                                                                    opacity: '0.6',
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    setOpenDropdownIndex(null);
                                                                                    setAnchorEl(null);
                                                                                    setIsOpenDeadline(false);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {((item?.property?.name === 'Status' &&
                                                                openStatusIndex === idx) ||
                                                                (item?.property?.name === 'Tag' &&
                                                                    openStatusIndex === idx) ||
                                                                (renderFieldValue() &&
                                                                    renderFieldValue().props &&
                                                                    renderFieldValue().props.children)) && (
                                                                    <div className="" ref={statusTagDropdownRef}>
                                                                        {item?.property?.name === 'Status' &&
                                                                            openStatusIndex === idx ? (
                                                                            <div>
                                                                                <StatusDropdown
                                                                                    item={item}
                                                                                    idx={idx}
                                                                                    StatusFields={defaultStatus}
                                                                                    handleUpdateCell={handleUpdateCell}
                                                                                    handleStatusClick={handleStatusClick}
                                                                                    handleUpdatedCustomField={
                                                                                        handleUpdatedCustomField
                                                                                    }
                                                                                    deleteCustomField={deleteCustomField}
                                                                                    getDefaultColorByValue={
                                                                                        getDefaultColorByValue
                                                                                    }
                                                                                    statusColors={statusColors}
                                                                                    setSelecteStatusIndex={
                                                                                        setSelecteStatusIndex
                                                                                    }
                                                                                    selecteStatusIndex={selecteStatusIndex}
                                                                                    customeFiedId={customeFiedId}
                                                                                    setCustomeFieldId={setCustomeFieldId}
                                                                                    filterStatusVal={filterStatusVal}
                                                                                    taskItem={taskItem}
                                                                                    handletaskUpdate={handletaskUpdate}
                                                                                    customprokey={customprokey}
                                                                                    setCustomprokey={setCustomprokey}
                                                                                    updateCustomProKey={updateCustomProKey}
                                                                                    triggerTaskUpdate={triggerTaskUpdate}
                                                                                    setTriggerTaskUpdate={
                                                                                        setTriggerTaskUpdate
                                                                                    }
                                                                                    getAllProperty={getAllProperty}
                                                                                    selectedStatus={selectedStatus}
                                                                                    selectedFieldId={selectedFieldId}
                                                                                    setSelectedStatus={setSelectedStatus}
                                                                                    getPropertyByID={getPropertyByID}
                                                                                    getAllPropertyByTaskId={getAllPropertyByTaskId}
                                                                                />
                                                                            </div>
                                                                        ) : item?.property?.name === 'Tag' &&
                                                                            openStatusIndex === idx ? (
                                                                            <div key={idx}>
                                                                                <CustomTagSelect
                                                                                    item={item}
                                                                                    idx={idx}
                                                                                    openStatusIndex={openStatusIndex}
                                                                                    setOpenStatusIndex={setOpenStatusIndex}
                                                                                    handleStatusClick={handleStatusClick}
                                                                                    taskItem={taskItem}
                                                                                    statusColors={statusColors}
                                                                                    tagFieldsData={defaultTags}
                                                                                    selectedTags={selectedTags}
                                                                                    handleSelecteTag={handleSelecteTag}
                                                                                    setSelectedTagColor={
                                                                                        setSelectedTagColor
                                                                                    }
                                                                                    setSelectedFilterTagVal={
                                                                                        setSelectedFilterTagVal
                                                                                    }
                                                                                    selectedFilterTagVal={
                                                                                        selectedFilterTagVal
                                                                                    }
                                                                                    customeFiedId={customeFiedId}
                                                                                    setCustomeFieldId={setCustomeFieldId}
                                                                                    deleteCustomField={deleteCustomField}
                                                                                    editTagName={editTagName}
                                                                                    setEditTagName={setEditTagName}
                                                                                    handletaskUpdate={handletaskUpdate}
                                                                                    customprokey={customprokey}
                                                                                    setCustomprokey={setCustomprokey}
                                                                                    updateCustomProKey={updateCustomProKey}
                                                                                    triggerTaskUpdate={triggerTaskUpdate}
                                                                                    selectedFieldId={selectedFieldId}
                                                                                    setTriggerTaskUpdate={
                                                                                        setTriggerTaskUpdate
                                                                                    }
                                                                                    filterTagProperty={filterTagProperty}
                                                                                    getPropertyByID={getPropertyByID}
                                                                                    getAllProperty={getAllProperty}
                                                                                    getAllPropertyByTaskId={getAllPropertyByTaskId}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            renderFieldValue()
                                                                        )}
                                                                    </div>
                                                                )}

                                                            {item?.property?.name === 'Tag' &&
                                                                selectedFieldId.length > 0 && (
                                                                    <div className="flex flex-wrap gap-1">
                                                                        {selectedFieldId.map(
                                                                            (selectedField, SelectedIndex) => {
                                                                                if (
                                                                                    getTagLabelByIdTag(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    )
                                                                                ) {
                                                                                    return (
                                                                                        <span
                                                                                            key={SelectedIndex}
                                                                                            className="text-xs rounded p-1 px-2 font-medium"
                                                                                            style={{
                                                                                                color:
                                                                                                    getTagLabelColorByIdTag(
                                                                                                        filteredFieldDetails,
                                                                                                        selectedField,
                                                                                                    ) || '#2196f3',
                                                                                                border: `1px solid ${getTagLabelColorByIdTag(
                                                                                                    filteredFieldDetails,
                                                                                                    selectedField,
                                                                                                ) || '#2196f3'
                                                                                                    }`,
                                                                                                borderRadius: '999px',
                                                                                            }}
                                                                                        >
                                                                                            #
                                                                                            {getTagLabelByIdTag(
                                                                                                filteredFieldDetails,
                                                                                                selectedField,
                                                                                            )}
                                                                                        </span>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            },
                                                                        )}
                                                                    </div>
                                                                )}

                                                            {item?.property?.name === 'Status' &&
                                                                selectedFieldId.length > 0 &&
                                                                selectedFieldId.map((selectedField, SelectedIndex) => {
                                                                    if (
                                                                        getTagLabelByIdStatus(
                                                                            filteredFieldDetails,
                                                                            selectedField,
                                                                        )
                                                                    ) {
                                                                        return (
                                                                            <div>
                                                                                <span
                                                                                    key={SelectedIndex}
                                                                                    className="text-xs rounded p-1 px-2 font-medium"
                                                                                    style={{
                                                                                        color: 'white',
                                                                                        background: `${getTagLabelColorByIdStatus(
                                                                                            filteredFieldDetails,
                                                                                            selectedField,
                                                                                        ) || 'grey'
                                                                                            }`,
                                                                                        borderRadius: '999px',
                                                                                    }}
                                                                                >
                                                                                    {getTagLabelByIdStatus(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    }
                                                                })}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-x-[10px]] mb-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    fill="currentColor"
                                    viewBox="0 0 22 22"
                                >
                                    <path d="M16.5 6.75v7.5a4.5 4.5 0 1 1-9 0V5.25a3.75 3.75 0 1 1 7.5 0v8.25a2.25 2.25 0 1 1-4.5 0V7.5h1.5v6a.75.75 0 0 0 1.5 0V5.25a2.25 2.25 0 0 0-4.5 0v9a3.75 3.75 0 1 0 7.5 0v-7.5z" />
                                </svg>
                                <input
                                    id="file-upload"
                                    type="file"
                                    ref={attachmentUploadRef}
                                    multiple
                                    accept="image/*"
                                    className="hidden"
                                    onClick={() => { attachmentUploadRef.current.value = null; }}
                                    onChange={(e) => { handleUploadTaskAttachmentFileChange(e); }}
                                />

                                <button
                                    className=" text-secondary px-2 py-1 rounded text-xs font-semibold transition "
                                    onClick={() => attachmentUploadRef.current && attachmentUploadRef.current.click()}
                                >
                                    Upload
                                </button>
                            </div>
                            <div className="relative w-full">
                                <div className="add-property relative flex gap-[15px] items-center border border-[#f5f5f5] text-[.7rem] mt-[17px] border-b-[5px] border-[#f5f5f5]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-plus-lg text-[#1b72e8]"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg>
                                    <h3
                                        onClick={addPropertyName}
                                        style={{
                                            color: '#1b72e8 !important',
                                            position: 'relative',
                                            marginBottom: '0.5rem',
                                            marginTop: '0.5rem',
                                            cursor: 'pointer',
                                            fontWeight: '600 !important',
                                        }}
                                    >
                                        Add a property
                                    </h3>
                                </div>
                            </div>

                            <div>
                                {showAllAttachment?.length > 0 ? <>
                                    <div className="flex justify-between  text-[#757575] p-1 text-[0.7rem]" >
                                        <div>Attachment ({showAllAttachment?.length})</div>
                                        <div className='cursor-pointer' onClick={handleClickAttachFile}>Attach File</div>
                                    </div>


                                </> : null}

                                <div className="mt-1 flex flex-col gap-2">
                                    {showAllAttachment?.map((file, index) => {
                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${file?.finalName}`;
                                        const ext = file.finalName.split('.').pop().toLowerCase();




                                        return (
                                            <div
                                                key={index}
                                                onMouseEnter={() => setHoverIndex(index)}
                                                onMouseLeave={() => setHoverIndex(null)}
                                                className="relative flex items-center justify-between  text-[0.7rem] text-gray-700 bg-gray-100 px-2 py-1 rounded cursor-pointer"
                                            >
                                                <div className="flex items-center w-full">
                                                    <span
                                                        className="cursor-pointer text-gray-500 flex items-center gap-1"
                                                        onClick={() => window.open(`${fileUrl}`, "_blank")}
                                                    >

                                                        <img src={getFileIcon(file?.finalName)} alt="file icon" className="w-5 h-5 object-contain" />
                                                        {/* {file?.finalName} */}
                                                    </span>
                                                    <div className="flex flex-col items-start text-gray-600 ml-2 max-w-[50%]">
                                                        <div className="flex gap-2 text-xs">
                                                            <span className='font-bold'>{name}</span>
                                                            <span style={{ fontSize: '10px' }}>
                                                                {file?.date
                                                                    ? new Date(file.date).toLocaleDateString(undefined, {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "2-digit",
                                                                    })
                                                                    : ""}
                                                            </span>

                                                        </div>
                                                        <div className="text-[0.65rem] truncate max-w-full text-gray-500" title={file?.path}>
                                                            {file?.finalName}
                                                        </div>
                                                    </div>
                                                </div>
                                                {hoverIndex === index && (
                                                    <svg
                                                        onClick={() => handleTogglePopup(index)}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-down-circle transition-opacity duration-200 cursor-pointer"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                                        <path d="M3.7 6.7a1 1 0 0 1 1.4 0L8 9.6l2.9-2.9a1 1 0 1 1 1.4 1.4l-3.6 3.6a1 1 0 0 1-1.4 0l-3.6-3.6a1 1 0 0 1 0-1.4z" />
                                                    </svg>
                                                )}

                                                {openIndex === index && (
                                                    <div
                                                        ref={dropattachmentRef}
                                                        onClick={() => deleteAttachementFile(file?.id)}
                                                        className="absolute w-full max-w-[40%] top-full right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg text-xs z-10 flex items-center"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-x"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                        </svg>
                                                        <button className="flex items-center px-2 py-1 hover:bg-gray-100 w-full text-left gap-2">
                                                            Delete
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}

                                </div>


                            </div>
                            <div className="mt-2 relative">
                                <div className="flex gap-6 border-b border-[#f5f5f5] text-xs">
                                    <button
                                        className={`py-2 px-0 border-b-2 font-bold bg-transparent ${activeTab === 'comments'
                                            ? 'border-[#184683] text-[#184683]'
                                            : 'border-transparent text-[#757575]'
                                            }`}
                                        onClick={() => setActiveTab('comments')}
                                    >
                                        Comments
                                    </button>
                                </div>
                                <div className="py-3 text-[#757575] text-xs min-h-[40px]">
                                    {activeTab === 'comments' ? (
                                        comments.length === 0 ? (
                                            'No comments'
                                        ) : (
                                            <div className="space-y-4 ">
                                                {comments.map((c, idx) => {
                                                    const plainText = stripTags(c.comment);
                                                    const highlightedText = highlightMentions(
                                                        plainText
                                                            .split('\n')
                                                            .map((line) => line.trim())
                                                            .filter((line) => line.length)
                                                            .join('\n'),
                                                    ).replace(/\n/g, '<br/>');
                                                    const userName = c.User?.name || "";
                                                    return (
                                                        <li
                                                            key={c.id || idx}
                                                            ref={idx === comments.length - 1 ? lastCommentRef : null}
                                                            className="flex gap-3 items-start border-b pb-3"
                                                        >
                                                            <div className="w-9 h-9 rounded-full bg-[#1CA7EC] flex items-center justify-center text-white font-bold text-lg">
                                                                {getUserInitials(userName)}
                                                            </div>
                                                            <div className="flex-1 w-50">
                                                                <div className="flex items-center gap-2">
                                                                    <span className="font-bold text-black">
                                                                        {toTitleCase(userName) || 'Admin'}
                                                                    </span>
                                                                    <span
                                                                        className="text-gray-500"
                                                                        style={{ fontSize: '10px' }}
                                                                    >
                                                                        {formatDateForDisplay(c.createdAt)}
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    className="mt-1 text-black text-sm break-words whitespace-pre-wrap"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightedText,
                                                                    }}
                                                                />
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </div>
                                        )
                                    ) : (
                                        <div className="space-y-4">
                                            {activityLog.map((a, idx) => (
                                                <li key={a.id || idx} className="flex gap-3 items-start border-b pb-3">
                                                    <div
                                                        className="w-9 h-9 rounded-full bg-[#1CA7EC] flex items-center justify-center text-white font-bold text-base min-w-[36px] min-h-[36px]"
                                                        style={{ justifyContent: 'center' }}
                                                    >
                                                        {a.text?.[0]?.toUpperCase() || 'K'}
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-2">
                                                            <span className="font-bold text-black">
                                                                {a.text?.split(' ')[0] || 'User'}
                                                            </span>
                                                            <span className="text-xs text-gray-500">{a.time}</span>
                                                            <span className="w-2 h-2 bg-[#1CA7EC] rounded-full inline-block"></span>
                                                        </div>

                                                        <div className="mt-1 text-black text-sm">{a.text}</div>
                                                    </div>
                                                </li>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    {activeTab === 'comments' && (
                        <div
                            className="border-b border-solid border-gray-300 sticky bottom-0 left-0 bg-white relative flex items-start gap-2 py-2 bottom-0"
                            style={showUserDropdown ? { marginTop: '40px' } : {}}
                        >
                            <div className="w-9 h-9 rounded-full bg-[#1CA7EC] flex items-center justify-center text-white font-bold text-base min-w-[36px] min-h-[36px]">
                                {userInitial || 'K'}
                            </div>

                            <div className="flex-1 relative">
                                {showUserDropdown && (
                                    <div className="absolute -top-8 left-0 w-full z-30 user-dropdown-container">
                                        <DropDown
                                            autoFocus
                                            searchable={true}
                                            multi={false}
                                            options={allUser}
                                            values={selectedUsers ? selectedUsers : []}
                                            onChange={handleUserSelection}
                                            labelField="name"
                                            valueField="email"
                                            placeholder="Search users..."
                                            className="custom-user-select"
                                            dropdownHeight="200px"
                                            searchFn={({ props, state }) =>
                                                state.search
                                                    ? props.options.filter((user) =>
                                                        user.name.toLowerCase().includes(state.search.toLowerCase()),
                                                    )
                                                    : props.options
                                            }
                                            itemRenderer={({ item, methods }) => (
                                                <div
                                                    className="user-option"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '5px 10px',
                                                        cursor: 'pointer',
                                                        borderBottom: '1px solid #eee',
                                                    }}
                                                    onClick={() => methods.addItem(item)}
                                                >
                                                    <div
                                                        style={{
                                                            width: '24px',
                                                            height: '24px',
                                                            borderRadius: '50%',
                                                            backgroundColor: getColorForUser(item.name),
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bold',
                                                            marginRight: '10px',
                                                            textTransform: 'uppercase',
                                                        }}
                                                    >
                                                        {item.name ? item.name[0] : ''}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontWeight: '500' }}>{item.name}</div>
                                                    </div>
                                                </div>
                                            )}
                                            onDropdownClose={() => setShowUserDropdown(false)}
                                        />
                                    </div>
                                )}

                                <div className="flex items-center gap-2">
                                    <div className="flex-1 relative">
                                        <textarea
                                            id="comments"
                                            placeholder="Add a comment"
                                            className="w-full py-2 pl-3 pr-20 rounded border border-[#e0e0e0] text-sm focus:outline-none focus:border-[#1CA7EC] transition resize-none min-h-[36px]"
                                            value={commentInput}
                                            onChange={(e) => setCommentInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    if (commentInput.trim() === '') {
                                                        toast.error('Please enter a comment');
                                                        return;
                                                    }
                                                    handleAddComment();
                                                }
                                            }}
                                            rows={3}
                                            style={{ paddingRight: 60, backgroundColor: 'white' }}
                                            disabled={!hasChatPermission}
                                        />

                                        <span
                                            className="absolute right-9 top-1/4 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-gray-600  bg-white px-1"
                                            style={{ pointerEvents: 'auto' }}
                                            onClick={toggleUserDropdown}
                                            title="Select users to mention"
                                        >
                                            @
                                        </span>

                                        <button
                                            className="absolute right-3 top-1/4 transform -translate-y-1/2 p-1 rounded-full  flex items-center justify-center"
                                            onClick={() => {
                                                if (commentInput.trim() === '') {
                                                    toast.error('Please enter a comment');
                                                    return;
                                                }
                                                handleAddComment();
                                            }}
                                            type="button"
                                            disabled={!hasChatPermission}
                                        >
                                            <IoIosSend />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showArchiveConfirmation && (
                        <ConfirmationPopup
                            customMessage="Are you sure you want to complete this task?"
                            onCancel={handleCancelArchive}
                            deleteTaskMail={handleConfirmArchive}
                        />
                    )}
                    {confimationModal && (
                        <Modal
                            show={confimationModal}
                            onHide={() => setConfimationModal(false)}
                            centered
                            size="lg"
                        >
                            <Modal.Header className='border-bottom  mb-2' closeButton>
                                <Modal.Title className="fw-bold">Task Trip</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <h4 className="mb-3">Choose how you want to proceed</h4>

                                <div className="d-flex flex-column">
                                    {/* Create new trip */}
                                    <div
                                        className="d-flex align-items-center justify-content-between py-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            handleCreateNewTrip();
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2  fw-semibold">
                                            <FiPlus />
                                            <h6 className="fw-bold">Create New Trip</h6>
                                        </div>

                                        <FaArrowRight className="text-primary fw-semibold" />
                                    </div>
                                    <p className="text-muted fs-7">
                                        Start from scratch and create a brand-new trip.
                                    </p>
                                    <hr />
                                    {/* Clone existing trip */}
                                    <div
                                        className="d-flex align-items-center justify-content-between py-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            handleCloneTrip();
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2 fw-semibold">
                                            <FiCopy />
                                            <h6 className="fw-bold">Clone Existing Trip</h6>

                                        </div>

                                        <FaArrowRight className="text-primary fw-semibold" />
                                    </div>
                                    <p className="text-muted fs-7">
                                        Duplicate an existing trip and modify it.
                                    </p>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setConfimationModal(false)}>
                                    Cancel
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}



                    {showTripList && (
                        <Modal
                            show={showTripList}
                            onHide={handleCloseTripList}
                            centered
                            size="xl"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title className="fw-bold">Trip List</Modal.Title>
                            </Modal.Header>

                            <Modal.Body >
                                <div className="row 
                                p-0 mx-0">
                                    <div className="col-12">
                                        <div className="card  card-flush rounded-2">
                                            <div className="table-responsive rounded-2">
                                                <table className="table table-bordered table-hover align-middle fs-6 gy-4 my-0 pb-3" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                    <thead className="border-gray-200 py-3 fs-6 fw-bold sticky-header light-blue-bg">

                                                        <tr>
                                                            <th className="text-center" style={{ width: '5%', color: 'inherit', fontFamily: 'Inter' }}>S.No</th>
                                                            <th style={{ width: '15%', color: 'inherit', fontFamily: 'Inter' }}>Ref.</th>
                                                            <th style={{ width: '15%', color: 'inherit', fontFamily: 'Inter' }}>Title</th>
                                                            <th style={{ width: '15%', color: 'inherit', fontFamily: 'Inter' }}>Starts At</th>
                                                            <th style={{ width: '15%', color: 'inherit', fontFamily: 'Inter' }}>Ends At</th>
                                                            <th className="text-center" style={{ width: '10%', color: 'inherit', fontFamily: 'Inter' }}>Action</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? <tr>
                                                            <td colSpan="5" className="text-center py-5">
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <div className="spinner-border text-primary" role="status">
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr> : tripId?.map((trip, index) => (
                                                            <tr key={trip.id || index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td className="ms-3">
                                                                    {trip?.trip?.id?.slice(0, 6).toUpperCase()}
                                                                </td>
                                                                <td className="text-sm truncate max-w-[150px]  align-middle" title={trip?.trip?.title || '-'}>
                                                                    {trip?.trip?.title || '-'}
                                                                </td>
                                                                <td>{moment(trip?.trip?.startDate).format('DD/MM/YYYY')}</td>
                                                                <td>{moment(trip?.trip?.endDate).format('DD/MM/YYYY')}</td>
                                                                <td>

                                                                    <div className="d-flex justify-content-center">
                                                                        <button
                                                                            ref={(el) =>
                                                                            (actionButtonRefs.current[trip?.trip?.id] =
                                                                                el)
                                                                            }
                                                                            className="btn btn-sm btn-icon btn-light btn-active-light-primary"
                                                                            type="button"
                                                                            id={`dropdownMenuButton-${trip?.trip?.id}`}
                                                                            aria-expanded={
                                                                                openActionMenu === trip?.trip?.id
                                                                            }
                                                                            onClick={(e) => {
                                                                                if (openActionMenu === trip?.trip?.id) {
                                                                                    setOpenActionMenu(null);
                                                                                } else {
                                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                                    const viewportHeight = window.innerHeight;
                                                                                    const viewportWidth = window.innerWidth;
                                                                                    const dropdownHeight = 300;
                                                                                    const dropdownWidth = 260;
                                                                                    const padding = 10;

                                                                                    const spaceBelow = viewportHeight - rect.bottom;
                                                                                    const spaceAbove = rect.top;

                                                                                    const placeAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

                                                                                    let top = placeAbove ? rect.top - dropdownHeight : rect.bottom;
                                                                                    top = Math.max(padding, Math.min(top, viewportHeight - dropdownHeight - padding));

                                                                                    const buttonCenter = rect.left + rect.width / 2;
                                                                                    let left = buttonCenter - dropdownWidth / 2;
                                                                                    left = Math.max(padding, Math.min(left, viewportWidth - dropdownWidth - padding));

                                                                                    setDropdownPosition({ top, left });
                                                                                    setOpenActionMenu(trip?.trip?.id);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FiMoreVertical fontSize={20} />
                                                                        </button>
                                                                        <ul
                                                                            className={`dropdown-menu ${openActionMenu === trip?.trip?.id
                                                                                ? "show"
                                                                                : ""
                                                                                }`}
                                                                            aria-labelledby={`dropdownMenuButton-${trip?.trip?.id}`}
                                                                            style={{
                                                                                position: "fixed",
                                                                                top: `${dropdownPosition.top}px`,
                                                                                left: `${dropdownPosition.left}px`,
                                                                                margin: "0px",
                                                                                minWidth: "220px",
                                                                                maxHeight: "80vh",
                                                                                overflowY: "auto",
                                                                                maxHeight: "80vh",
                                                                                overflowY: "auto",
                                                                                zIndex: 2000,
                                                                            }}
                                                                        >
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Link Status:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.linkStatus}
                                                                                    handleChange={() => {
                                                                                        handleUpdate(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Show Price:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.showPrice}
                                                                                    handleChange={() => {
                                                                                        handleUpdateShowPrice(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Show Detail Price:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.showDetailPrice}
                                                                                    handleChange={() => {
                                                                                        handleUpdateShowDetailPrice(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>

                                                                            <li className="dropdown-divider"></li>

                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    data-tooltip-id="my-tooltip"
                                                                                    data-tooltip-content="Edit"
                                                                                    data-tooltip-placement="top"
                                                                                    title="Edit"
                                                                                    onClick={() => {
                                                                                        const parentUrl = parentOrigin + `/tripboard/${trip?.trip?.id}`;
                                                                                        const newWin = window.open(parentUrl, "_blank");
                                                                                        setNewWindow(newWin);

                                                                                        const sendData = () => {
                                                                                            if (newWin && !newWin.closed) {
                                                                                                newWin.postMessage({
                                                                                                    type: "TASK_DATA",
                                                                                                    taskId: currentTaskId,
                                                                                                    editTask: true
                                                                                                }, parentOrigin);
                                                                                            }
                                                                                        };

                                                                                        const interval = setInterval(sendData, 500);
                                                                                        setTimeout(() => clearInterval(interval), 3000);

                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <FiEdit className="me-2" />Edit
                                                                                    Trip
                                                                                </button>
                                                                            </li>
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    onClick={() => {
                                                                                        setCopyData(trip?.trip);
                                                                                        setModal(true);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <FiCopy className="me-2" /> Copy
                                                                                    Trip
                                                                                </button>
                                                                            </li>
                                                                            <li>

                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    data-tooltip-id="my-tooltip"
                                                                                    data-tooltip-content=" View/Share Link"
                                                                                    data-tooltip-placement="top"
                                                                                    onClick={() => {
                                                                                        copyLinkHandler(trip?.trip?.id);
                                                                                    }}
                                                                                >
                                                                                    <FiLink className="me-2" /> View/Share Link
                                                                                </button>

                                                                            </li>
                                                                            {/* <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    onClick={() =>
                                                                                        openCancelModal(trip?.trip)
                                                                                    }
                                                                                >
                                                                                    <FiXCircle className="me-2" />{" "}
                                                                                    Cancel booking
                                                                                </button>
                                                                            </li> */}
                                                                            <li className="dropdown-divider"></li>
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center text-danger"
                                                                                    onClick={() => {
                                                                                        setDeleteID(trip?.trip?.id);
                                                                                        setModalShow(true);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <MdDeleteOutline
                                                                                        className="me-2"
                                                                                        fontSize={20}
                                                                                    />{" "}
                                                                                    Delete Trip
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseTripList}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}

                </div>
            </div>
            <WarningModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                title={"Delete Trip"}
                handleYes={handleYes}
                className="btn btn-primary-new"
            />
            <Confirmation
                show={modal}
                onHide={() => setModal(false)}
                title={"Copy Tour"}
                handleYes={() => { setModal(false); handleCopy() }}
            />
            <CancelBookingModal
                show={showCancelModal}
                onHide={() => { setShowCancelModal(false), setOpenActionMenu(null) }}
                booking={selectedBookingTrip}
                type="Trip"
                setOpenActionMenu={setOpenActionMenu}
            />
            <Tooltip id="my-tooltip" />
        </>
    );
};

TaskData.propTypes = {
    gmailMassageID: PropTypes.string,
    taskItem: PropTypes.object.isRequired,
    updateTaskMail: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    getTaskMail: PropTypes.func.isRequired,
    setCurrentTask: PropTypes.func.isRequired,
    setTaskDetailModal: PropTypes.func.isRequired,
};
export default TaskData;
